import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONB: { input: any; output: any; }
  Map: { input: any; output: any; }
  NullBool: { input: any; output: any; }
  NullInt64: { input: any; output: any; }
  NullString: { input: string; output: string; }
  NullTime: { input: any; output: any; }
  Numeric: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type GQLAddTranslationParams = {
  En: Scalars['String']['input'];
  Key: Scalars['String']['input'];
  Namespace: Scalars['String']['input'];
  Nl?: InputMaybe<Scalars['NullString']['input']>;
};

export type GQLAllTenantFormsRow = {
  __typename?: 'AllTenantFormsRow';
  customForm?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  formID?: Maybe<Scalars['Int']['output']>;
  isConfigurable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLAssignTaskParams = {
  assignedTo: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
};

export type GQLAvailableFormsRow = {
  __typename?: 'AvailableFormsRow';
  customForm?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['NullString']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  formID?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLCategoryNode = {
  __typename?: 'CategoryNode';
  categoryID: Scalars['ID']['output'];
  children?: Maybe<Array<GQLCategoryNode>>;
  items?: Maybe<Array<GQLContentItem>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLContentForm = {
  __typename?: 'ContentForm';
  defaultData?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['NullString']['output']>;
  formID: Scalars['ID']['output'];
  formSchema?: Maybe<Scalars['JSON']['output']>;
  formVersion: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uiSchema?: Maybe<Scalars['JSON']['output']>;
};

export type GQLContentFormResult = {
  formData: Scalars['JSON']['input'];
  formID: Scalars['ID']['input'];
  formResultID?: InputMaybe<Scalars['ID']['input']>;
  formVersion: Scalars['ID']['input'];
};

export type GQLContentItem = {
  __typename?: 'ContentItem';
  createdAt?: Maybe<Scalars['NullTime']['output']>;
  createdBy?: Maybe<Scalars['NullString']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['NullString']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  itemID: Scalars['ID']['output'];
  mimetype?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['ID']['output']>;
  sensitivityLevel?: Maybe<Scalars['ID']['output']>;
};

export type GQLDictionary = {
  __typename?: 'Dictionary';
  en: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  nl?: Maybe<Scalars['NullString']['output']>;
};

export type GQLDisabledTenantFormPartsByFormIdRow = {
  __typename?: 'DisabledTenantFormPartsByFormIDRow';
  formID?: Maybe<Scalars['ID']['output']>;
  formPartID?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLDisabledTenantFormsRow = {
  __typename?: 'DisabledTenantFormsRow';
  customForm?: Maybe<Scalars['Boolean']['output']>;
  formID?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLEnabledTenantFormPartsByFormIdRow = {
  __typename?: 'EnabledTenantFormPartsByFormIDRow';
  formID?: Maybe<Scalars['ID']['output']>;
  formPartID?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLEnabledTenantFormsRow = {
  __typename?: 'EnabledTenantFormsRow';
  customForm?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['NullString']['output']>;
  formID?: Maybe<Scalars['Int']['output']>;
  isConfigurable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLFetchContentItemsStructureRow = {
  __typename?: 'FetchContentItemsStructureRow';
  categoryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['NullTime']['output']>;
  createdBy?: Maybe<Scalars['NullString']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['NullString']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  itemID: Scalars['ID']['output'];
  mimetype?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentID: Scalars['ID']['output'];
  path?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['ID']['output']>;
  sensitivityLevel?: Maybe<Scalars['ID']['output']>;
};

export type GQLFetchFlatMenuRow = {
  __typename?: 'FetchFlatMenuRow';
  featureDescriptionLabel?: Maybe<Scalars['String']['output']>;
  featureID?: Maybe<Scalars['ID']['output']>;
  featureName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['NullString']['output']>;
  menuID?: Maybe<Scalars['ID']['output']>;
  menuOrder?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentID?: Maybe<Scalars['NullInt64']['output']>;
  permission?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['NullString']['output']>;
};

export type GQLFormResultByIdRow = {
  __typename?: 'FormResultByIDRow';
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<GQLIamUser>;
  formData?: Maybe<Scalars['JSON']['output']>;
  formID?: Maybe<Scalars['ID']['output']>;
  formResultID?: Maybe<Scalars['ID']['output']>;
  formSchema?: Maybe<Scalars['JSON']['output']>;
  formVersion?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['NullTime']['output']>;
  uiSchema?: Maybe<Scalars['JSON']['output']>;
};

export type GQLIamPermission = {
  __typename?: 'IamPermission';
  description?: Maybe<Scalars['NullString']['output']>;
  permissionID?: Maybe<Scalars['ID']['output']>;
  permissionName?: Maybe<Scalars['String']['output']>;
};

export type GQLIamRole = {
  __typename?: 'IamRole';
  description?: Maybe<Scalars['NullString']['output']>;
  roleID?: Maybe<Scalars['ID']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
};

export type GQLIamUser = {
  __typename?: 'IamUser';
  active?: Maybe<Scalars['Boolean']['output']>;
  avatar?: Maybe<Scalars['NullString']['output']>;
  branchID?: Maybe<Scalars['ID']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  infix?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  preferences?: Maybe<Scalars['JSONB']['output']>;
  roles?: Maybe<Array<GQLIamRole>>;
  tenantDetails?: Maybe<GQLTenantDetailsRow>;
  tenantID?: Maybe<Scalars['UUID']['output']>;
  userID?: Maybe<Scalars['String']['output']>;
};

export type GQLKpiIncidentsByCategoryRow = {
  __typename?: 'KpiIncidentsByCategoryRow';
  category?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type GQLMutation = {
  __typename?: 'Mutation';
  ActivateTenantFromRegistrationID: GQLSuccess;
  AddTranslation: GQLSuccess;
  AssignTask?: Maybe<GQLSuccess>;
  NewCategory?: Maybe<GQLSuccess>;
  NewContentItem?: Maybe<GQLSuccess>;
  NewTask?: Maybe<GQLSuccess>;
  NewTenantRegistration: GQLSuccess;
  NewUser: GQLIamUser;
  RemoveCategory?: Maybe<GQLSuccess>;
  RemoveContentItem?: Maybe<GQLSuccess>;
  RemoveDraftForm?: Maybe<GQLSuccess>;
  RequestResetPassword?: Maybe<GQLSuccess>;
  SetUserPreferences: GQLSuccess;
  SetUserStatus: GQLSuccess;
  StoreForm?: Maybe<GQLContentForm>;
  StoreFormResult: Scalars['ID']['output'];
  SubmitFormResult?: Maybe<GQLSuccess>;
  TaskNewComment?: Maybe<GQLSuccess>;
  TenantNewBranch: GQLSuccess;
  TenantRegistrationCreateAdmin: GQLSuccess;
  TenantRegistrationSetStatus: GQLSuccess;
  TenantSetStatus: GQLSuccess;
  TenantUpdateBranch: GQLSuccess;
  UpdateCategoryName?: Maybe<GQLSuccess>;
  UpdateContentItemRoles?: Maybe<GQLSuccess>;
  UpdateCustomForm?: Maybe<GQLSuccess>;
  UpdateEnabledFeatures: GQLSuccess;
  UpdateTask?: Maybe<GQLSuccess>;
  UpdateTaskStatus?: Maybe<GQLSuccess>;
  UpdateTenantForm?: Maybe<GQLSuccess>;
  UpdateTenantFormPartsByFormID?: Maybe<GQLSuccess>;
  UpdateTenantOrganization: GQLSuccess;
  UpdateTenantRegistration: GQLSuccess;
  UpdateTranslation: GQLSuccess;
  UpdateUserByID: GQLSuccess;
  UpdateUserRoles: GQLSuccess;
};


export type GQLMutationActivateTenantFromRegistrationIdArgs = {
  registrationID: Scalars['ID']['input'];
};


export type GQLMutationAddTranslationArgs = {
  input: GQLAddTranslationParams;
};


export type GQLMutationAssignTaskArgs = {
  input: GQLAssignTaskParams;
};


export type GQLMutationNewCategoryArgs = {
  categoryName: Scalars['String']['input'];
};


export type GQLMutationNewContentItemArgs = {
  category: Scalars['ID']['input'];
  item: GQLNewItemParams;
};


export type GQLMutationNewTaskArgs = {
  input: GQLNewTaskParams;
};


export type GQLMutationNewTenantRegistrationArgs = {
  input: GQLNewRegistrationParams;
};


export type GQLMutationNewUserArgs = {
  input: GQLNewUserParams;
};


export type GQLMutationRemoveCategoryArgs = {
  categoryID: Scalars['ID']['input'];
};


export type GQLMutationRemoveContentItemArgs = {
  itemID: Scalars['ID']['input'];
};


export type GQLMutationRemoveDraftFormArgs = {
  formResultID: Scalars['ID']['input'];
};


export type GQLMutationRequestResetPasswordArgs = {
  userID: Scalars['String']['input'];
};


export type GQLMutationSetUserPreferencesArgs = {
  preferences: Scalars['JSONB']['input'];
};


export type GQLMutationSetUserStatusArgs = {
  active: Scalars['Boolean']['input'];
  userID: Scalars['String']['input'];
};


export type GQLMutationStoreFormArgs = {
  input: GQLStoreFormParams;
  newVersion?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GQLMutationStoreFormResultArgs = {
  input: GQLContentFormResult;
};


export type GQLMutationSubmitFormResultArgs = {
  formDataID: Scalars['ID']['input'];
};


export type GQLMutationTaskNewCommentArgs = {
  input: GQLTaskNewCommentParams;
};


export type GQLMutationTenantNewBranchArgs = {
  branchInput: GQLNewBranchParams;
};


export type GQLMutationTenantRegistrationCreateAdminArgs = {
  registrationID: Scalars['ID']['input'];
};


export type GQLMutationTenantRegistrationSetStatusArgs = {
  registrationID: Scalars['ID']['input'];
  status: GQLRegistrationStatus;
};


export type GQLMutationTenantSetStatusArgs = {
  input: GQLTenantSetStatusParams;
};


export type GQLMutationTenantUpdateBranchArgs = {
  branchInput: GQLUpdateBranchParams;
};


export type GQLMutationUpdateCategoryNameArgs = {
  input: GQLUpdateCategoryNameParams;
};


export type GQLMutationUpdateContentItemRolesArgs = {
  input?: InputMaybe<GQLUpdateContentItemRoleParams>;
};


export type GQLMutationUpdateCustomFormArgs = {
  enabled: Scalars['Boolean']['input'];
  formID: Scalars['Int']['input'];
};


export type GQLMutationUpdateEnabledFeaturesArgs = {
  input: GQLUpdateTenantEnabledFeaturesParams;
};


export type GQLMutationUpdateTaskArgs = {
  input: GQLUpdateTaskParams;
};


export type GQLMutationUpdateTaskStatusArgs = {
  input: GQLUpdateTaskStatusParams;
};


export type GQLMutationUpdateTenantFormArgs = {
  enabled: Scalars['Boolean']['input'];
  formID: Scalars['Int']['input'];
};


export type GQLMutationUpdateTenantFormPartsByFormIdArgs = {
  formID: Scalars['ID']['input'];
  formParts: Array<Scalars['String']['input']>;
};


export type GQLMutationUpdateTenantOrganizationArgs = {
  enabledFeatures?: InputMaybe<Array<Scalars['ID']['input']>>;
  organiztionInput: GQLUpdateOrganizationParams;
  tenantInput: GQLUpdateTenantParams;
};


export type GQLMutationUpdateTenantRegistrationArgs = {
  input: GQLUpdateRegistrationParams;
};


export type GQLMutationUpdateTranslationArgs = {
  input: GQLUpdateTranslationParams;
};


export type GQLMutationUpdateUserByIdArgs = {
  input: GQLUpdateUserByIdParams;
};


export type GQLMutationUpdateUserRolesArgs = {
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
  userID: Scalars['String']['input'];
};

export type GQLMyDraftFormsRow = {
  __typename?: 'MyDraftFormsRow';
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['NullString']['output']>;
  formData?: Maybe<Scalars['JSON']['output']>;
  formID: Scalars['ID']['output'];
  formResultID: Scalars['ID']['output'];
  formSchema?: Maybe<Scalars['JSON']['output']>;
  formVersion: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uiSchema?: Maybe<Scalars['JSON']['output']>;
};

export type GQLNewBranchParams = {
  branchName: Scalars['String']['input'];
  branchType: Scalars['String']['input'];
  tenantID?: InputMaybe<Scalars['UUID']['input']>;
};

export type GQLNewItemParams = {
  description?: InputMaybe<Scalars['NullString']['input']>;
  downloadURL: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roles: Array<Scalars['ID']['input']>;
};

export type GQLNewRegistrationParams = {
  adminEmailAddress: Scalars['String']['input'];
  adminFirstName: Scalars['String']['input'];
  adminInfix?: InputMaybe<Scalars['NullString']['input']>;
  adminLastName: Scalars['String']['input'];
  adminPhoneNumber?: InputMaybe<Scalars['NullString']['input']>;
  city: Scalars['String']['input'];
  emailAddressInvoice: Scalars['NullString']['input'];
  houseNumber: Scalars['String']['input'];
  isTrial: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  purchaseNumber?: InputMaybe<Scalars['NullString']['input']>;
  reference?: InputMaybe<Scalars['NullString']['input']>;
  street: Scalars['String']['input'];
};

export type GQLNewTaskParams = {
  FormResultID?: InputMaybe<Scalars['ID']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['Time']['input'];
  priority: Scalars['String']['input'];
  summary: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GQLNewUserParams = {
  branchID?: InputMaybe<Scalars['ID']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  infix: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GQLOpenTasksByFormResultIdRow = {
  __typename?: 'OpenTasksByFormResultIdRow';
  dueDate?: Maybe<Scalars['Time']['output']>;
  openTasks?: Maybe<Scalars['Int']['output']>;
};

export type GQLQuery = {
  __typename?: 'Query';
  AllTenantFeatures?: Maybe<Array<GQLTenantFeature>>;
  AllTenantForms?: Maybe<Array<GQLAllTenantFormsRow>>;
  AllUserTenants?: Maybe<Array<GQLTenantAllUserTenant>>;
  AvailableForms?: Maybe<Array<GQLAvailableFormsRow>>;
  CategoryStructure?: Maybe<Array<GQLCategoryNode>>;
  ContentItemsByCategoryID?: Maybe<Array<GQLContentItem>>;
  Dictionary: Scalars['JSON']['output'];
  DisabledTenantFormPartsByFormID?: Maybe<Array<GQLDisabledTenantFormPartsByFormIdRow>>;
  DisabledTenantForms?: Maybe<Array<GQLDisabledTenantFormsRow>>;
  EnabledFeatures?: Maybe<Array<Scalars['String']['output']>>;
  EnabledForms?: Maybe<Array<GQLContentForm>>;
  EnabledTenantFormPartsByFormID?: Maybe<Array<GQLEnabledTenantFormPartsByFormIdRow>>;
  EnabledTenantForms?: Maybe<Array<GQLEnabledTenantFormsRow>>;
  FetchContentItemsStructure?: Maybe<Array<GQLFetchContentItemsStructureRow>>;
  FlatMenus?: Maybe<Array<GQLFetchFlatMenuRow>>;
  FormByID: GQLContentForm;
  FormDesignerByID: GQLContentForm;
  FormResultByID?: Maybe<GQLFormResultByIdRow>;
  IsPermitted?: Maybe<Scalars['Boolean']['output']>;
  KPIDraftForms: Scalars['Int']['output'];
  KPIIncidentsByCategory?: Maybe<Array<GQLKpiIncidentsByCategoryRow>>;
  KPISubmittedForms12Months: Scalars['Int']['output'];
  KPISubmittedWPI12Months: Scalars['Int']['output'];
  MyDraftForms?: Maybe<Array<GQLMyDraftFormsRow>>;
  MyOpenTasks: Array<GQLTask>;
  OpenTenantRegistrations?: Maybe<Array<GQLTenantRegistration>>;
  Roles?: Maybe<Array<GQLIamRole>>;
  SubmittedForms?: Maybe<Array<GQLSubmittedFormsRow>>;
  TaskByTaskID: GQLTask;
  TaskCommentsByTaskID: Array<GQLTaskComment>;
  TaskOverview: Array<GQLTask>;
  TaskOverviewByFormResultID: Array<GQLTask>;
  TasksByMultipleFormIDs: Array<GQLTask>;
  TenantBranchByID?: Maybe<GQLTenantBranch>;
  TenantBranches?: Maybe<Array<GQLTenantBranch>>;
  TenantCompanyDetails?: Maybe<GQLTenantDetailsRow>;
  TenantOrganizationDetails?: Maybe<Array<GQLTenantOrganizationDetailsRow>>;
  TenantRegistrationByID: GQLTenantRegistration;
  Translations?: Maybe<Array<GQLDictionary>>;
  UserAccountByUserID?: Maybe<GQLIamUser>;
  UserAccounts?: Maybe<Array<GQLIamUser>>;
  currentUser?: Maybe<GQLIamUser>;
};


export type GQLQueryContentItemsByCategoryIdArgs = {
  categoryID: Scalars['ID']['input'];
};


export type GQLQueryDisabledTenantFormPartsByFormIdArgs = {
  formID: Scalars['ID']['input'];
};


export type GQLQueryEnabledTenantFormPartsByFormIdArgs = {
  formID: Scalars['ID']['input'];
};


export type GQLQueryFormByIdArgs = {
  formID: Scalars['ID']['input'];
};


export type GQLQueryFormDesignerByIdArgs = {
  formID: Scalars['ID']['input'];
};


export type GQLQueryFormResultByIdArgs = {
  formResultID: Scalars['ID']['input'];
};


export type GQLQueryIsPermittedArgs = {
  permission?: InputMaybe<Scalars['String']['input']>;
};


export type GQLQuerySubmittedFormsArgs = {
  input: GQLSubmittedFormsParams;
};


export type GQLQueryTaskByTaskIdArgs = {
  taskID: Scalars['ID']['input'];
};


export type GQLQueryTaskCommentsByTaskIdArgs = {
  taskID: Scalars['ID']['input'];
};


export type GQLQueryTaskOverviewArgs = {
  filter: GQLTaskWithfilterOptionsParams;
};


export type GQLQueryTaskOverviewByFormResultIdArgs = {
  formResultID: Scalars['ID']['input'];
};


export type GQLQueryTasksByMultipleFormIDsArgs = {
  formIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type GQLQueryTenantBranchByIdArgs = {
  branchID: Scalars['ID']['input'];
};


export type GQLQueryTenantRegistrationByIdArgs = {
  registrationID: Scalars['ID']['input'];
};


export type GQLQueryUserAccountByUserIdArgs = {
  userID: Scalars['String']['input'];
};


export type GQLQueryUserAccountsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GQLRegistrationStatus {
  AdminDone = 'ADMIN_DONE',
  Completed = 'COMPLETED',
  Invoiced = 'INVOICED',
  Trial = 'TRIAL'
}

export type GQLStoreFormParams = {
  description?: InputMaybe<Scalars['NullString']['input']>;
  formID: Scalars['ID']['input'];
  formSchema: Scalars['JSON']['input'];
  formVersion?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uiSchema: Scalars['JSON']['input'];
};

export type GQLSubmittedFormsParams = {
  endDate: Scalars['Time']['input'];
  startDate: Scalars['Time']['input'];
};

export type GQLSubmittedFormsRow = {
  __typename?: 'SubmittedFormsRow';
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<GQLIamUser>;
  formID?: Maybe<Scalars['ID']['output']>;
  formResultID?: Maybe<Scalars['ID']['output']>;
  formVersion?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['NullTime']['output']>;
};

export type GQLSuccess = {
  __typename?: 'Success';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GQLTask = {
  __typename?: 'Task';
  FormResultID?: Maybe<Scalars['ID']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  branchID?: Maybe<Scalars['ID']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Time']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  taskID?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GQLTaskComment = {
  __typename?: 'TaskComment';
  commentID?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  taskID?: Maybe<Scalars['ID']['output']>;
};

export type GQLTaskNewCommentParams = {
  description?: InputMaybe<Scalars['String']['input']>;
  taskID: Scalars['ID']['input'];
};

export type GQLTaskWithfilterOptionsParams = {
  assignedTo?: InputMaybe<Array<Scalars['String']['input']>>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  statusFilter: Array<Scalars['String']['input']>;
};

export type GQLTenantAllUserTenant = {
  __typename?: 'TenantAllUserTenant';
  TenantID?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLTenantBranch = {
  __typename?: 'TenantBranch';
  branchID: Scalars['ID']['output'];
  branchName?: Maybe<Scalars['String']['output']>;
  branchType?: Maybe<Scalars['String']['output']>;
  tenantID?: Maybe<Scalars['UUID']['output']>;
};

export type GQLTenantDetailsRow = {
  __typename?: 'TenantDetailsRow';
  config?: Maybe<Scalars['JSON']['output']>;
  logo?: Maybe<Scalars['NullString']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GQLTenantFeature = {
  __typename?: 'TenantFeature';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  featureDescriptionLabel: Scalars['String']['output'];
  featureID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLTenantOrganizationDetailsRow = {
  __typename?: 'TenantOrganizationDetailsRow';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['NullTime']['output']>;
  emailAddressInvoice?: Maybe<Scalars['NullString']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  enabledFeatures?: Maybe<Array<GQLTenantFeature>>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['NullString']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationID: Scalars['ID']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  purchaseNumber?: Maybe<Scalars['NullString']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tenantID?: Maybe<Scalars['UUID']['output']>;
  trialStartDate?: Maybe<Scalars['NullTime']['output']>;
};

export type GQLTenantRegistration = {
  __typename?: 'TenantRegistration';
  adminEmailAddress?: Maybe<Scalars['String']['output']>;
  adminFirstName?: Maybe<Scalars['String']['output']>;
  adminInfix?: Maybe<Scalars['NullString']['output']>;
  adminLastName?: Maybe<Scalars['String']['output']>;
  adminPhoneNumber?: Maybe<Scalars['NullString']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  emailAddressInvoice?: Maybe<Scalars['NullString']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  isTrial?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  purchaseNumber?: Maybe<Scalars['NullString']['output']>;
  registrationID: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tenantID?: Maybe<Scalars['UUID']['output']>;
};

export type GQLTenantSetStatusParams = {
  status: Scalars['String']['input'];
  tenantID: Scalars['UUID']['input'];
};

export enum GQLTenantStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Trial = 'TRIAL',
  TrialExpired = 'TRIAL_EXPIRED'
}

export type GQLUpdateBranchParams = {
  branchID: Scalars['ID']['input'];
  branchName: Scalars['String']['input'];
  branchType: Scalars['String']['input'];
};

export type GQLUpdateCategoryNameParams = {
  categoryID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type GQLUpdateContentItemRoleParams = {
  itemID: Scalars['ID']['input'];
  roles: Array<Scalars['ID']['input']>;
};

export type GQLUpdateOrganizationParams = {
  city?: InputMaybe<Scalars['String']['input']>;
  emailAddressInvoice?: InputMaybe<Scalars['NullString']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  purchaseNumber?: InputMaybe<Scalars['NullString']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateRegistrationParams = {
  adminEmailAddress: Scalars['String']['input'];
  adminFirstName: Scalars['String']['input'];
  adminInfix?: InputMaybe<Scalars['NullString']['input']>;
  adminLastName: Scalars['String']['input'];
  adminPhoneNumber?: InputMaybe<Scalars['NullString']['input']>;
  city: Scalars['String']['input'];
  emailAddressInvoice: Scalars['NullString']['input'];
  houseNumber: Scalars['String']['input'];
  isTrial: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  purchaseNumber?: InputMaybe<Scalars['NullString']['input']>;
  registrationID: Scalars['ID']['input'];
  street: Scalars['String']['input'];
};

export type GQLUpdateTaskParams = {
  dueDate: Scalars['Time']['input'];
  priority: Scalars['String']['input'];
  summary: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type GQLUpdateTaskStatusParams = {
  status: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
};

export type GQLUpdateTenantEnabledFeaturesParams = {
  enabledFeatures: Array<Scalars['ID']['input']>;
  tenantID?: InputMaybe<Scalars['UUID']['input']>;
};

export type GQLUpdateTenantParams = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  tenantID: Scalars['UUID']['input'];
  trialStartDate?: InputMaybe<Scalars['NullTime']['input']>;
};

export type GQLUpdateTranslationParams = {
  En: Scalars['String']['input'];
  Key: Scalars['String']['input'];
  Namespace: Scalars['String']['input'];
  NewKey: Scalars['String']['input'];
  NewNamespace: Scalars['String']['input'];
  Nl?: InputMaybe<Scalars['NullString']['input']>;
};

export type GQLUpdateUserByIdParams = {
  branchID?: InputMaybe<Scalars['ID']['input']>;
  firstName: Scalars['String']['input'];
  infix: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roles?: InputMaybe<Array<Scalars['ID']['input']>>;
  userID: Scalars['String']['input'];
};

export type GQLVoid = {
  __typename?: 'Void';
  void?: Maybe<Scalars['String']['output']>;
};

export type GQLActivateTenantFromRegistrationIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLActivateTenantFromRegistrationIdMutation = { __typename?: 'Mutation', ActivateTenantFromRegistrationID: { __typename?: 'Success', success?: boolean | null } };

export type GQLAddTranslationMutationVariables = Exact<{
  input: GQLAddTranslationParams;
}>;


export type GQLAddTranslationMutation = { __typename?: 'Mutation', AddTranslation: { __typename?: 'Success', success?: boolean | null } };

export type GQLAssignTaskMutationVariables = Exact<{
  input: GQLAssignTaskParams;
}>;


export type GQLAssignTaskMutation = { __typename?: 'Mutation', AssignTask?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLNewCategoryMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type GQLNewCategoryMutation = { __typename?: 'Mutation', NewCategory?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLNewContentItemMutationVariables = Exact<{
  input: GQLNewItemParams;
  catID: Scalars['ID']['input'];
}>;


export type GQLNewContentItemMutation = { __typename?: 'Mutation', NewContentItem?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLNewTaskMutationVariables = Exact<{
  input: GQLNewTaskParams;
}>;


export type GQLNewTaskMutation = { __typename?: 'Mutation', NewTask?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLNewTenantRegistrationMutationVariables = Exact<{
  input: GQLNewRegistrationParams;
}>;


export type GQLNewTenantRegistrationMutation = { __typename?: 'Mutation', NewTenantRegistration: { __typename?: 'Success', success?: boolean | null } };

export type GQLNewUserMutationVariables = Exact<{
  input: GQLNewUserParams;
}>;


export type GQLNewUserMutation = { __typename?: 'Mutation', NewUser: { __typename?: 'IamUser', userID?: string | null } };

export type GQLRemoveCategoryMutationVariables = Exact<{
  categoryID: Scalars['ID']['input'];
}>;


export type GQLRemoveCategoryMutation = { __typename?: 'Mutation', RemoveCategory?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLRemoveContentItemMutationVariables = Exact<{
  itemID: Scalars['ID']['input'];
}>;


export type GQLRemoveContentItemMutation = { __typename?: 'Mutation', RemoveContentItem?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLRemoveDraftFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLRemoveDraftFormMutation = { __typename?: 'Mutation', RemoveDraftForm?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLRequestResetPasswordMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GQLRequestResetPasswordMutation = { __typename?: 'Mutation', RequestResetPassword?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLSetUserPreferencesMutationVariables = Exact<{
  input: Scalars['JSONB']['input'];
}>;


export type GQLSetUserPreferencesMutation = { __typename?: 'Mutation', SetUserPreferences: { __typename?: 'Success', success?: boolean | null } };

export type GQLSetUserStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type GQLSetUserStatusMutation = { __typename?: 'Mutation', SetUserStatus: { __typename?: 'Success', success?: boolean | null } };

export type GQLStoreFormMutationVariables = Exact<{
  input: GQLStoreFormParams;
}>;


export type GQLStoreFormMutation = { __typename?: 'Mutation', StoreForm?: { __typename?: 'ContentForm', formID: string, name?: string | null, description?: string | null, formSchema?: any | null, uiSchema?: any | null, defaultData?: any | null } | null };

export type GQLStoreFormResultMutationVariables = Exact<{
  input: GQLContentFormResult;
}>;


export type GQLStoreFormResultMutation = { __typename?: 'Mutation', StoreFormResult: string };

export type GQLSubmitFormResultMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLSubmitFormResultMutation = { __typename?: 'Mutation', SubmitFormResult?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLTaskNewCommentMutationVariables = Exact<{
  input: GQLTaskNewCommentParams;
}>;


export type GQLTaskNewCommentMutation = { __typename?: 'Mutation', TaskNewComment?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLTenantNewBranchMutationVariables = Exact<{
  branchInput: GQLNewBranchParams;
}>;


export type GQLTenantNewBranchMutation = { __typename?: 'Mutation', TenantNewBranch: { __typename?: 'Success', success?: boolean | null } };

export type GQLTenantRegistrationCreateAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLTenantRegistrationCreateAdminMutation = { __typename?: 'Mutation', TenantRegistrationCreateAdmin: { __typename?: 'Success', success?: boolean | null } };

export type GQLTenantRegistrationSetStatusMutationVariables = Exact<{
  registrationID: Scalars['ID']['input'];
  status: GQLRegistrationStatus;
}>;


export type GQLTenantRegistrationSetStatusMutation = { __typename?: 'Mutation', TenantRegistrationSetStatus: { __typename?: 'Success', success?: boolean | null } };

export type GQLTenantSetStatusMutationVariables = Exact<{
  input: GQLTenantSetStatusParams;
}>;


export type GQLTenantSetStatusMutation = { __typename?: 'Mutation', TenantSetStatus: { __typename?: 'Success', success?: boolean | null } };

export type GQLTenantUpdateBranchMutationVariables = Exact<{
  branchInput: GQLUpdateBranchParams;
}>;


export type GQLTenantUpdateBranchMutation = { __typename?: 'Mutation', TenantUpdateBranch: { __typename?: 'Success', success?: boolean | null } };

export type GQLUpdateCategoryNameMutationVariables = Exact<{
  input: GQLUpdateCategoryNameParams;
}>;


export type GQLUpdateCategoryNameMutation = { __typename?: 'Mutation', UpdateCategoryName?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateContentItemRolesMutationVariables = Exact<{
  input?: InputMaybe<GQLUpdateContentItemRoleParams>;
}>;


export type GQLUpdateContentItemRolesMutation = { __typename?: 'Mutation', UpdateContentItemRoles?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateCustomFormMutationVariables = Exact<{
  formID: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type GQLUpdateCustomFormMutation = { __typename?: 'Mutation', UpdateCustomForm?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTaskMutationVariables = Exact<{
  input: GQLUpdateTaskParams;
}>;


export type GQLUpdateTaskMutation = { __typename?: 'Mutation', UpdateTask?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTaskStatusMutationVariables = Exact<{
  input: GQLUpdateTaskStatusParams;
}>;


export type GQLUpdateTaskStatusMutation = { __typename?: 'Mutation', UpdateTaskStatus?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTenantFormMutationVariables = Exact<{
  formID: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type GQLUpdateTenantFormMutation = { __typename?: 'Mutation', UpdateTenantForm?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTenantFormPartsByFormIdMutationVariables = Exact<{
  formID: Scalars['ID']['input'];
  formParts: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GQLUpdateTenantFormPartsByFormIdMutation = { __typename?: 'Mutation', UpdateTenantFormPartsByFormID?: { __typename?: 'Success', success?: boolean | null } | null };

export type GQLUpdateTenantOrganizationMutationVariables = Exact<{
  tenantInput: GQLUpdateTenantParams;
  organizationInput: GQLUpdateOrganizationParams;
  enabledFeatures?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GQLUpdateTenantOrganizationMutation = { __typename?: 'Mutation', UpdateTenantOrganization: { __typename?: 'Success', success?: boolean | null } };

export type GQLUpdateTenantRegistrationMutationVariables = Exact<{
  input: GQLUpdateRegistrationParams;
}>;


export type GQLUpdateTenantRegistrationMutation = { __typename?: 'Mutation', UpdateTenantRegistration: { __typename?: 'Success', success?: boolean | null } };

export type GQLUpdateTranslationMutationVariables = Exact<{
  input: GQLUpdateTranslationParams;
}>;


export type GQLUpdateTranslationMutation = { __typename?: 'Mutation', UpdateTranslation: { __typename?: 'Success', success?: boolean | null } };

export type GQLUpdateUserByIdMutationVariables = Exact<{
  input: GQLUpdateUserByIdParams;
}>;


export type GQLUpdateUserByIdMutation = { __typename?: 'Mutation', UpdateUserByID: { __typename?: 'Success', success?: boolean | null } };

export type GQLAllTenantFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLAllTenantFeaturesQuery = { __typename?: 'Query', AllTenantFeatures?: Array<{ __typename?: 'TenantFeature', featureID: string, name: string, enabled?: boolean | null, featureDescriptionLabel: string }> | null };

export type GQLAllTenantFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLAllTenantFormsQuery = { __typename?: 'Query', AllTenantForms?: Array<{ __typename?: 'AllTenantFormsRow', name?: string | null, formID?: number | null, customForm?: boolean | null, enabled?: boolean | null, isConfigurable?: boolean | null }> | null };

export type GQLCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'IamUser', emailAddress?: string | null, userID?: string | null, active?: boolean | null, preferences?: any | null, avatar?: string | null, permissions?: Array<string> | null, firstName?: string | null, infix?: string | null, lastName?: string | null, tenantID?: any | null, branchID?: string | null, branchName?: string | null, roles?: Array<{ __typename?: 'IamRole', roleID?: string | null, roleName?: string | null, description?: string | null }> | null, tenantDetails?: { __typename?: 'TenantDetailsRow', name?: string | null, logo?: string | null, config?: any | null } | null } | null };

export type GQLEnabledFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLEnabledFeaturesQuery = { __typename?: 'Query', EnabledFeatures?: Array<string> | null };

export type GQLGetEnabledFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetEnabledFormsQuery = { __typename?: 'Query', EnabledForms?: Array<{ __typename?: 'ContentForm', formID: string, formVersion: string, name?: string | null, description?: string | null, defaultData?: any | null }> | null };

export type GQLFlatMenusQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLFlatMenusQuery = { __typename?: 'Query', FlatMenus?: Array<{ __typename?: 'FetchFlatMenuRow', menuID?: string | null, menuOrder?: string | null, name?: string | null, icon?: string | null, route?: string | null, parentID?: any | null, featureDescriptionLabel?: string | null, featureID?: string | null, featureName?: string | null, permission?: string | null }> | null };

export type GQLFormByIdQueryVariables = Exact<{
  formID: Scalars['ID']['input'];
}>;


export type GQLFormByIdQuery = { __typename?: 'Query', FormByID: { __typename?: 'ContentForm', formID: string, formVersion: string, name?: string | null, description?: string | null, formSchema?: any | null, uiSchema?: any | null, defaultData?: any | null } };

export type GQLFormDesignerByIdQueryVariables = Exact<{
  formID: Scalars['ID']['input'];
}>;


export type GQLFormDesignerByIdQuery = { __typename?: 'Query', FormDesignerByID: { __typename?: 'ContentForm', formID: string, formVersion: string, name?: string | null, description?: string | null, formSchema?: any | null, uiSchema?: any | null, defaultData?: any | null } };

export type GQLGetAllUserTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetAllUserTenantsQuery = { __typename?: 'Query', AllUserTenants?: Array<{ __typename?: 'TenantAllUserTenant', name?: string | null, TenantID?: any | null }> | null };

export type GQLGetAvailableFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetAvailableFormsQuery = { __typename?: 'Query', AvailableForms?: Array<{ __typename?: 'AvailableFormsRow', name?: string | null, formID?: number | null, description?: string | null, enabled?: boolean | null, customForm?: boolean | null }> | null };

export type GQLGetCategoryStructureQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetCategoryStructureQuery = { __typename?: 'Query', CategoryStructure?: Array<{ __typename?: 'CategoryNode', categoryID: string, name?: string | null, children?: Array<{ __typename?: 'CategoryNode', categoryID: string, name?: string | null }> | null, items?: Array<{ __typename?: 'ContentItem', itemID: string, name?: string | null, description?: string | null, createdAt?: any | null, createdBy?: string | null, sensitivityLevel?: string | null, deleted?: boolean | null, mimetype?: string | null, downloadUrl?: string | null, roles: Array<string> }> | null }> | null };

export type GQLGetContentItemsByCategoryIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetContentItemsByCategoryIdQuery = { __typename?: 'Query', ContentItemsByCategoryID?: Array<{ __typename?: 'ContentItem', itemID: string, name?: string | null, description?: string | null, createdAt?: any | null, createdBy?: string | null, sensitivityLevel?: string | null, deleted?: boolean | null, roles: Array<string>, mimetype?: string | null }> | null };

export type GQLGetDisabledTenantFormPartsByFormIdQueryVariables = Exact<{
  formID: Scalars['ID']['input'];
}>;


export type GQLGetDisabledTenantFormPartsByFormIdQuery = { __typename?: 'Query', DisabledTenantFormPartsByFormID?: Array<{ __typename?: 'DisabledTenantFormPartsByFormIDRow', name?: string | null, formPartID?: string | null, formID?: string | null }> | null };

export type GQLGetEnabledTenantFormPartsByFormIdQueryVariables = Exact<{
  formID: Scalars['ID']['input'];
}>;


export type GQLGetEnabledTenantFormPartsByFormIdQuery = { __typename?: 'Query', EnabledTenantFormPartsByFormID?: Array<{ __typename?: 'EnabledTenantFormPartsByFormIDRow', name?: string | null, formPartID?: string | null, formID?: string | null }> | null };

export type GQLGetFormResultByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetFormResultByIdQuery = { __typename?: 'Query', FormResultByID?: { __typename?: 'FormResultByIDRow', formResultID?: string | null, formID?: string | null, formVersion?: string | null, name?: string | null, formSchema?: any | null, uiSchema?: any | null, formData?: any | null, createdAt?: any | null, submittedAt?: any | null, createdBy?: { __typename?: 'IamUser', firstName?: string | null, infix?: string | null, lastName?: string | null, tenantID?: any | null } | null } | null };

export type GQLGetKpiDraftFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetKpiDraftFormsQuery = { __typename?: 'Query', KPIDraftForms: number };

export type GQLGetKpiIncidentsByCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetKpiIncidentsByCategoryQuery = { __typename?: 'Query', KPIIncidentsByCategory?: Array<{ __typename?: 'KpiIncidentsByCategoryRow', category?: string | null, count?: number | null }> | null };

export type GQLGetKpiSubmittedForms12MonthsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetKpiSubmittedForms12MonthsQuery = { __typename?: 'Query', KPISubmittedForms12Months: number };

export type GQLGetKpiSubmittedWpi12MonthsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetKpiSubmittedWpi12MonthsQuery = { __typename?: 'Query', KPISubmittedWPI12Months: number };

export type GQLGetOpenTenantRegistrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetOpenTenantRegistrationsQuery = { __typename?: 'Query', OpenTenantRegistrations?: Array<{ __typename?: 'TenantRegistration', registrationID: string, tenantID?: any | null, name?: string | null, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null, emailAddressInvoice?: string | null, adminEmailAddress?: string | null, adminFirstName?: string | null, adminInfix?: string | null, adminLastName?: string | null, adminPhoneNumber?: string | null, purchaseNumber?: string | null, status?: string | null, isTrial?: boolean | null }> | null };

export type GQLGetSubmittedFormsQueryVariables = Exact<{
  input: GQLSubmittedFormsParams;
}>;


export type GQLGetSubmittedFormsQuery = { __typename?: 'Query', SubmittedForms?: Array<{ __typename?: 'SubmittedFormsRow', formResultID?: string | null, formID?: string | null, formVersion?: string | null, name?: string | null, createdAt?: any | null, submittedAt?: any | null, createdBy?: { __typename?: 'IamUser', firstName?: string | null, infix?: string | null, lastName?: string | null, tenantID?: any | null } | null }> | null };

export type GQLGetTaskByTaskIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetTaskByTaskIdQuery = { __typename?: 'Query', TaskByTaskID: { __typename?: 'Task', taskID?: string | null, summary?: string | null, status?: string | null, type?: string | null, priority?: string | null, createdBy?: string | null, createdAt?: any | null, assignedTo?: string | null, assignedToName?: string | null, dueDate?: any | null, branchID?: string | null, url?: string | null } };

export type GQLGetTaskCommentsByTaskIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLGetTaskCommentsByTaskIdQuery = { __typename?: 'Query', TaskCommentsByTaskID: Array<{ __typename?: 'TaskComment', commentID?: string | null, taskID?: string | null, description?: string | null, createdBy?: string | null, createdAt?: any | null }> };

export type GQLGetTaskOverviewQueryVariables = Exact<{
  filter: GQLTaskWithfilterOptionsParams;
}>;


export type GQLGetTaskOverviewQuery = { __typename?: 'Query', TaskOverview: Array<{ __typename?: 'Task', FormResultID?: string | null, taskID?: string | null, summary?: string | null, status?: string | null, type?: string | null, priority?: string | null, createdBy?: string | null, createdAt?: any | null, assignedTo?: string | null, assignedToName?: string | null, dueDate?: any | null, url?: string | null, branchID?: string | null, branchName?: string | null }> };

export type GQLTaskOverviewByFormResultIdQueryVariables = Exact<{
  formResultID: Scalars['ID']['input'];
}>;


export type GQLTaskOverviewByFormResultIdQuery = { __typename?: 'Query', TaskOverviewByFormResultID: Array<{ __typename?: 'Task', taskID?: string | null, summary?: string | null, status?: string | null, type?: string | null, priority?: string | null, createdBy?: string | null, createdAt?: any | null, assignedTo?: string | null, assignedToName?: string | null, dueDate?: any | null, FormResultID?: string | null, url?: string | null, branchID?: string | null, branchName?: string | null }> };

export type GQLGetTenantOrganizationDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetTenantOrganizationDetailsQuery = { __typename?: 'Query', TenantOrganizationDetails?: Array<{ __typename?: 'TenantOrganizationDetailsRow', organizationID: string, tenantID?: any | null, name?: string | null, logo?: string | null, street?: string | null, houseNumber?: string | null, postalCode?: string | null, city?: string | null, emailAddressInvoice?: string | null, purchaseNumber?: string | null, enabled?: boolean | null, createdAt?: any | null, trialStartDate?: any | null, status?: string | null, enabledFeatures?: Array<{ __typename?: 'TenantFeature', featureID: string, name: string, enabled?: boolean | null, featureDescriptionLabel: string }> | null }> | null };

export type GQLGetTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetTranslationsQuery = { __typename?: 'Query', Translations?: Array<{ __typename?: 'Dictionary', id: string, namespace: string, key: string, en: string, nl?: string | null }> | null };

export type GQLGetUserAccountsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GQLGetUserAccountsQuery = { __typename?: 'Query', UserAccounts?: Array<{ __typename?: 'IamUser', emailAddress?: string | null, userID?: string | null, active?: boolean | null, preferences?: any | null, branchID?: string | null, branchName?: string | null, permissions?: Array<string> | null, firstName?: string | null, infix?: string | null, lastName?: string | null, tenantID?: any | null, fullName?: string | null, roles?: Array<{ __typename?: 'IamRole', roleID?: string | null, roleName?: string | null, description?: string | null }> | null }> | null };

export type GQLGetUserListQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GQLGetUserListQuery = { __typename?: 'Query', UserAccounts?: Array<{ __typename?: 'IamUser', id?: string | null, name?: string | null }> | null };

export type GQLIsPermittedQueryVariables = Exact<{
  permission: Scalars['String']['input'];
}>;


export type GQLIsPermittedQuery = { __typename?: 'Query', IsPermitted?: boolean | null };

export type GQLGetMyDraftFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetMyDraftFormsQuery = { __typename?: 'Query', MyDraftForms?: Array<{ __typename?: 'MyDraftFormsRow', formResultID: string, formID: string, formVersion: string, name?: string | null, description?: string | null, formSchema?: any | null, uiSchema?: any | null, formData?: any | null, createdAt?: any | null }> | null };

export type GQLMyOpenTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLMyOpenTasksQuery = { __typename?: 'Query', MyOpenTasks: Array<{ __typename?: 'Task', taskID?: string | null, FormResultID?: string | null, summary?: string | null, status?: string | null, type?: string | null, priority?: string | null, createdBy?: string | null, createdAt?: any | null, assignedTo?: string | null, assignedToName?: string | null, dueDate?: any | null, url?: string | null, branchID?: string | null, branchName?: string | null }> };

export type GQLGetUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLGetUserRolesQuery = { __typename?: 'Query', Roles?: Array<{ __typename?: 'IamRole', roleID?: string | null, roleName?: string | null }> | null };

export type GQLTenantBranchByIdQueryVariables = Exact<{
  branchID: Scalars['ID']['input'];
}>;


export type GQLTenantBranchByIdQuery = { __typename?: 'Query', TenantBranchByID?: { __typename?: 'TenantBranch', branchID: string, branchName?: string | null, branchType?: string | null, tenantID?: any | null } | null };

export type GQLTenantBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLTenantBranchesQuery = { __typename?: 'Query', TenantBranches?: Array<{ __typename?: 'TenantBranch', branchID: string, branchName?: string | null, branchType?: string | null, tenantID?: any | null }> | null };


export const ActivateTenantFromRegistrationIdDocument = gql`
    mutation ActivateTenantFromRegistrationID($id: ID!) {
  ActivateTenantFromRegistrationID(registrationID: $id) {
    success
  }
}
    `;
export type GQLActivateTenantFromRegistrationIdMutationFn = Apollo.MutationFunction<GQLActivateTenantFromRegistrationIdMutation, GQLActivateTenantFromRegistrationIdMutationVariables>;

/**
 * __useActivateTenantFromRegistrationIdMutation__
 *
 * To run a mutation, you first call `useActivateTenantFromRegistrationIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTenantFromRegistrationIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTenantFromRegistrationIdMutation, { data, loading, error }] = useActivateTenantFromRegistrationIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateTenantFromRegistrationIdMutation(baseOptions?: Apollo.MutationHookOptions<GQLActivateTenantFromRegistrationIdMutation, GQLActivateTenantFromRegistrationIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLActivateTenantFromRegistrationIdMutation, GQLActivateTenantFromRegistrationIdMutationVariables>(ActivateTenantFromRegistrationIdDocument, options);
      }
export type ActivateTenantFromRegistrationIdMutationHookResult = ReturnType<typeof useActivateTenantFromRegistrationIdMutation>;
export type ActivateTenantFromRegistrationIdMutationResult = Apollo.MutationResult<GQLActivateTenantFromRegistrationIdMutation>;
export type ActivateTenantFromRegistrationIdMutationOptions = Apollo.BaseMutationOptions<GQLActivateTenantFromRegistrationIdMutation, GQLActivateTenantFromRegistrationIdMutationVariables>;
export const AddTranslationDocument = gql`
    mutation addTranslation($input: AddTranslationParams!) {
  AddTranslation(input: $input) {
    success
  }
}
    `;
export type GQLAddTranslationMutationFn = Apollo.MutationFunction<GQLAddTranslationMutation, GQLAddTranslationMutationVariables>;

/**
 * __useAddTranslationMutation__
 *
 * To run a mutation, you first call `useAddTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTranslationMutation, { data, loading, error }] = useAddTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTranslationMutation(baseOptions?: Apollo.MutationHookOptions<GQLAddTranslationMutation, GQLAddTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLAddTranslationMutation, GQLAddTranslationMutationVariables>(AddTranslationDocument, options);
      }
export type AddTranslationMutationHookResult = ReturnType<typeof useAddTranslationMutation>;
export type AddTranslationMutationResult = Apollo.MutationResult<GQLAddTranslationMutation>;
export type AddTranslationMutationOptions = Apollo.BaseMutationOptions<GQLAddTranslationMutation, GQLAddTranslationMutationVariables>;
export const AssignTaskDocument = gql`
    mutation AssignTask($input: AssignTaskParams!) {
  AssignTask(input: $input) {
    success
  }
}
    `;
export type GQLAssignTaskMutationFn = Apollo.MutationFunction<GQLAssignTaskMutation, GQLAssignTaskMutationVariables>;

/**
 * __useAssignTaskMutation__
 *
 * To run a mutation, you first call `useAssignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskMutation, { data, loading, error }] = useAssignTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTaskMutation(baseOptions?: Apollo.MutationHookOptions<GQLAssignTaskMutation, GQLAssignTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLAssignTaskMutation, GQLAssignTaskMutationVariables>(AssignTaskDocument, options);
      }
export type AssignTaskMutationHookResult = ReturnType<typeof useAssignTaskMutation>;
export type AssignTaskMutationResult = Apollo.MutationResult<GQLAssignTaskMutation>;
export type AssignTaskMutationOptions = Apollo.BaseMutationOptions<GQLAssignTaskMutation, GQLAssignTaskMutationVariables>;
export const NewCategoryDocument = gql`
    mutation NewCategory($input: String!) {
  NewCategory(categoryName: $input) {
    success
  }
}
    `;
export type GQLNewCategoryMutationFn = Apollo.MutationFunction<GQLNewCategoryMutation, GQLNewCategoryMutationVariables>;

/**
 * __useNewCategoryMutation__
 *
 * To run a mutation, you first call `useNewCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newCategoryMutation, { data, loading, error }] = useNewCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewCategoryMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewCategoryMutation, GQLNewCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewCategoryMutation, GQLNewCategoryMutationVariables>(NewCategoryDocument, options);
      }
export type NewCategoryMutationHookResult = ReturnType<typeof useNewCategoryMutation>;
export type NewCategoryMutationResult = Apollo.MutationResult<GQLNewCategoryMutation>;
export type NewCategoryMutationOptions = Apollo.BaseMutationOptions<GQLNewCategoryMutation, GQLNewCategoryMutationVariables>;
export const NewContentItemDocument = gql`
    mutation NewContentItem($input: NewItemParams!, $catID: ID!) {
  NewContentItem(item: $input, category: $catID) {
    success
  }
}
    `;
export type GQLNewContentItemMutationFn = Apollo.MutationFunction<GQLNewContentItemMutation, GQLNewContentItemMutationVariables>;

/**
 * __useNewContentItemMutation__
 *
 * To run a mutation, you first call `useNewContentItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewContentItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newContentItemMutation, { data, loading, error }] = useNewContentItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *      catID: // value for 'catID'
 *   },
 * });
 */
export function useNewContentItemMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewContentItemMutation, GQLNewContentItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewContentItemMutation, GQLNewContentItemMutationVariables>(NewContentItemDocument, options);
      }
export type NewContentItemMutationHookResult = ReturnType<typeof useNewContentItemMutation>;
export type NewContentItemMutationResult = Apollo.MutationResult<GQLNewContentItemMutation>;
export type NewContentItemMutationOptions = Apollo.BaseMutationOptions<GQLNewContentItemMutation, GQLNewContentItemMutationVariables>;
export const NewTaskDocument = gql`
    mutation NewTask($input: NewTaskParams!) {
  NewTask(input: $input) {
    success
  }
}
    `;
export type GQLNewTaskMutationFn = Apollo.MutationFunction<GQLNewTaskMutation, GQLNewTaskMutationVariables>;

/**
 * __useNewTaskMutation__
 *
 * To run a mutation, you first call `useNewTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newTaskMutation, { data, loading, error }] = useNewTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewTaskMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewTaskMutation, GQLNewTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewTaskMutation, GQLNewTaskMutationVariables>(NewTaskDocument, options);
      }
export type NewTaskMutationHookResult = ReturnType<typeof useNewTaskMutation>;
export type NewTaskMutationResult = Apollo.MutationResult<GQLNewTaskMutation>;
export type NewTaskMutationOptions = Apollo.BaseMutationOptions<GQLNewTaskMutation, GQLNewTaskMutationVariables>;
export const NewTenantRegistrationDocument = gql`
    mutation NewTenantRegistration($input: NewRegistrationParams!) {
  NewTenantRegistration(input: $input) {
    success
  }
}
    `;
export type GQLNewTenantRegistrationMutationFn = Apollo.MutationFunction<GQLNewTenantRegistrationMutation, GQLNewTenantRegistrationMutationVariables>;

/**
 * __useNewTenantRegistrationMutation__
 *
 * To run a mutation, you first call `useNewTenantRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewTenantRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newTenantRegistrationMutation, { data, loading, error }] = useNewTenantRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewTenantRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewTenantRegistrationMutation, GQLNewTenantRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewTenantRegistrationMutation, GQLNewTenantRegistrationMutationVariables>(NewTenantRegistrationDocument, options);
      }
export type NewTenantRegistrationMutationHookResult = ReturnType<typeof useNewTenantRegistrationMutation>;
export type NewTenantRegistrationMutationResult = Apollo.MutationResult<GQLNewTenantRegistrationMutation>;
export type NewTenantRegistrationMutationOptions = Apollo.BaseMutationOptions<GQLNewTenantRegistrationMutation, GQLNewTenantRegistrationMutationVariables>;
export const NewUserDocument = gql`
    mutation NewUser($input: NewUserParams!) {
  NewUser(input: $input) {
    userID
  }
}
    `;
export type GQLNewUserMutationFn = Apollo.MutationFunction<GQLNewUserMutation, GQLNewUserMutationVariables>;

/**
 * __useNewUserMutation__
 *
 * To run a mutation, you first call `useNewUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newUserMutation, { data, loading, error }] = useNewUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewUserMutation(baseOptions?: Apollo.MutationHookOptions<GQLNewUserMutation, GQLNewUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLNewUserMutation, GQLNewUserMutationVariables>(NewUserDocument, options);
      }
export type NewUserMutationHookResult = ReturnType<typeof useNewUserMutation>;
export type NewUserMutationResult = Apollo.MutationResult<GQLNewUserMutation>;
export type NewUserMutationOptions = Apollo.BaseMutationOptions<GQLNewUserMutation, GQLNewUserMutationVariables>;
export const RemoveCategoryDocument = gql`
    mutation RemoveCategory($categoryID: ID!) {
  RemoveCategory(categoryID: $categoryID) {
    success
  }
}
    `;
export type GQLRemoveCategoryMutationFn = Apollo.MutationFunction<GQLRemoveCategoryMutation, GQLRemoveCategoryMutationVariables>;

/**
 * __useRemoveCategoryMutation__
 *
 * To run a mutation, you first call `useRemoveCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCategoryMutation, { data, loading, error }] = useRemoveCategoryMutation({
 *   variables: {
 *      categoryID: // value for 'categoryID'
 *   },
 * });
 */
export function useRemoveCategoryMutation(baseOptions?: Apollo.MutationHookOptions<GQLRemoveCategoryMutation, GQLRemoveCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRemoveCategoryMutation, GQLRemoveCategoryMutationVariables>(RemoveCategoryDocument, options);
      }
export type RemoveCategoryMutationHookResult = ReturnType<typeof useRemoveCategoryMutation>;
export type RemoveCategoryMutationResult = Apollo.MutationResult<GQLRemoveCategoryMutation>;
export type RemoveCategoryMutationOptions = Apollo.BaseMutationOptions<GQLRemoveCategoryMutation, GQLRemoveCategoryMutationVariables>;
export const RemoveContentItemDocument = gql`
    mutation RemoveContentItem($itemID: ID!) {
  RemoveContentItem(itemID: $itemID) {
    success
  }
}
    `;
export type GQLRemoveContentItemMutationFn = Apollo.MutationFunction<GQLRemoveContentItemMutation, GQLRemoveContentItemMutationVariables>;

/**
 * __useRemoveContentItemMutation__
 *
 * To run a mutation, you first call `useRemoveContentItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentItemMutation, { data, loading, error }] = useRemoveContentItemMutation({
 *   variables: {
 *      itemID: // value for 'itemID'
 *   },
 * });
 */
export function useRemoveContentItemMutation(baseOptions?: Apollo.MutationHookOptions<GQLRemoveContentItemMutation, GQLRemoveContentItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRemoveContentItemMutation, GQLRemoveContentItemMutationVariables>(RemoveContentItemDocument, options);
      }
export type RemoveContentItemMutationHookResult = ReturnType<typeof useRemoveContentItemMutation>;
export type RemoveContentItemMutationResult = Apollo.MutationResult<GQLRemoveContentItemMutation>;
export type RemoveContentItemMutationOptions = Apollo.BaseMutationOptions<GQLRemoveContentItemMutation, GQLRemoveContentItemMutationVariables>;
export const RemoveDraftFormDocument = gql`
    mutation RemoveDraftForm($id: ID!) {
  RemoveDraftForm(formResultID: $id) {
    success
  }
}
    `;
export type GQLRemoveDraftFormMutationFn = Apollo.MutationFunction<GQLRemoveDraftFormMutation, GQLRemoveDraftFormMutationVariables>;

/**
 * __useRemoveDraftFormMutation__
 *
 * To run a mutation, you first call `useRemoveDraftFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftFormMutation, { data, loading, error }] = useRemoveDraftFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDraftFormMutation(baseOptions?: Apollo.MutationHookOptions<GQLRemoveDraftFormMutation, GQLRemoveDraftFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRemoveDraftFormMutation, GQLRemoveDraftFormMutationVariables>(RemoveDraftFormDocument, options);
      }
export type RemoveDraftFormMutationHookResult = ReturnType<typeof useRemoveDraftFormMutation>;
export type RemoveDraftFormMutationResult = Apollo.MutationResult<GQLRemoveDraftFormMutation>;
export type RemoveDraftFormMutationOptions = Apollo.BaseMutationOptions<GQLRemoveDraftFormMutation, GQLRemoveDraftFormMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation RequestResetPassword($id: String!) {
  RequestResetPassword(userID: $id) {
    success
  }
}
    `;
export type GQLRequestResetPasswordMutationFn = Apollo.MutationFunction<GQLRequestResetPasswordMutation, GQLRequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<GQLRequestResetPasswordMutation, GQLRequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRequestResetPasswordMutation, GQLRequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<GQLRequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<GQLRequestResetPasswordMutation, GQLRequestResetPasswordMutationVariables>;
export const SetUserPreferencesDocument = gql`
    mutation SetUserPreferences($input: JSONB!) {
  SetUserPreferences(preferences: $input) {
    success
  }
}
    `;
export type GQLSetUserPreferencesMutationFn = Apollo.MutationFunction<GQLSetUserPreferencesMutation, GQLSetUserPreferencesMutationVariables>;

/**
 * __useSetUserPreferencesMutation__
 *
 * To run a mutation, you first call `useSetUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPreferencesMutation, { data, loading, error }] = useSetUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<GQLSetUserPreferencesMutation, GQLSetUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLSetUserPreferencesMutation, GQLSetUserPreferencesMutationVariables>(SetUserPreferencesDocument, options);
      }
export type SetUserPreferencesMutationHookResult = ReturnType<typeof useSetUserPreferencesMutation>;
export type SetUserPreferencesMutationResult = Apollo.MutationResult<GQLSetUserPreferencesMutation>;
export type SetUserPreferencesMutationOptions = Apollo.BaseMutationOptions<GQLSetUserPreferencesMutation, GQLSetUserPreferencesMutationVariables>;
export const SetUserStatusDocument = gql`
    mutation SetUserStatus($id: String!, $active: Boolean!) {
  SetUserStatus(userID: $id, active: $active) {
    success
  }
}
    `;
export type GQLSetUserStatusMutationFn = Apollo.MutationFunction<GQLSetUserStatusMutation, GQLSetUserStatusMutationVariables>;

/**
 * __useSetUserStatusMutation__
 *
 * To run a mutation, you first call `useSetUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserStatusMutation, { data, loading, error }] = useSetUserStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<GQLSetUserStatusMutation, GQLSetUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLSetUserStatusMutation, GQLSetUserStatusMutationVariables>(SetUserStatusDocument, options);
      }
export type SetUserStatusMutationHookResult = ReturnType<typeof useSetUserStatusMutation>;
export type SetUserStatusMutationResult = Apollo.MutationResult<GQLSetUserStatusMutation>;
export type SetUserStatusMutationOptions = Apollo.BaseMutationOptions<GQLSetUserStatusMutation, GQLSetUserStatusMutationVariables>;
export const StoreFormDocument = gql`
    mutation StoreForm($input: StoreFormParams!) {
  StoreForm(input: $input) {
    formID
    name
    description
    formSchema
    uiSchema
    defaultData
  }
}
    `;
export type GQLStoreFormMutationFn = Apollo.MutationFunction<GQLStoreFormMutation, GQLStoreFormMutationVariables>;

/**
 * __useStoreFormMutation__
 *
 * To run a mutation, you first call `useStoreFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeFormMutation, { data, loading, error }] = useStoreFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreFormMutation(baseOptions?: Apollo.MutationHookOptions<GQLStoreFormMutation, GQLStoreFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLStoreFormMutation, GQLStoreFormMutationVariables>(StoreFormDocument, options);
      }
export type StoreFormMutationHookResult = ReturnType<typeof useStoreFormMutation>;
export type StoreFormMutationResult = Apollo.MutationResult<GQLStoreFormMutation>;
export type StoreFormMutationOptions = Apollo.BaseMutationOptions<GQLStoreFormMutation, GQLStoreFormMutationVariables>;
export const StoreFormResultDocument = gql`
    mutation StoreFormResult($input: ContentFormResult!) {
  StoreFormResult(input: $input)
}
    `;
export type GQLStoreFormResultMutationFn = Apollo.MutationFunction<GQLStoreFormResultMutation, GQLStoreFormResultMutationVariables>;

/**
 * __useStoreFormResultMutation__
 *
 * To run a mutation, you first call `useStoreFormResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreFormResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeFormResultMutation, { data, loading, error }] = useStoreFormResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStoreFormResultMutation(baseOptions?: Apollo.MutationHookOptions<GQLStoreFormResultMutation, GQLStoreFormResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLStoreFormResultMutation, GQLStoreFormResultMutationVariables>(StoreFormResultDocument, options);
      }
export type StoreFormResultMutationHookResult = ReturnType<typeof useStoreFormResultMutation>;
export type StoreFormResultMutationResult = Apollo.MutationResult<GQLStoreFormResultMutation>;
export type StoreFormResultMutationOptions = Apollo.BaseMutationOptions<GQLStoreFormResultMutation, GQLStoreFormResultMutationVariables>;
export const SubmitFormResultDocument = gql`
    mutation SubmitFormResult($id: ID!) {
  SubmitFormResult(formDataID: $id) {
    success
  }
}
    `;
export type GQLSubmitFormResultMutationFn = Apollo.MutationFunction<GQLSubmitFormResultMutation, GQLSubmitFormResultMutationVariables>;

/**
 * __useSubmitFormResultMutation__
 *
 * To run a mutation, you first call `useSubmitFormResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormResultMutation, { data, loading, error }] = useSubmitFormResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitFormResultMutation(baseOptions?: Apollo.MutationHookOptions<GQLSubmitFormResultMutation, GQLSubmitFormResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLSubmitFormResultMutation, GQLSubmitFormResultMutationVariables>(SubmitFormResultDocument, options);
      }
export type SubmitFormResultMutationHookResult = ReturnType<typeof useSubmitFormResultMutation>;
export type SubmitFormResultMutationResult = Apollo.MutationResult<GQLSubmitFormResultMutation>;
export type SubmitFormResultMutationOptions = Apollo.BaseMutationOptions<GQLSubmitFormResultMutation, GQLSubmitFormResultMutationVariables>;
export const TaskNewCommentDocument = gql`
    mutation TaskNewComment($input: TaskNewCommentParams!) {
  TaskNewComment(input: $input) {
    success
  }
}
    `;
export type GQLTaskNewCommentMutationFn = Apollo.MutationFunction<GQLTaskNewCommentMutation, GQLTaskNewCommentMutationVariables>;

/**
 * __useTaskNewCommentMutation__
 *
 * To run a mutation, you first call `useTaskNewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskNewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskNewCommentMutation, { data, loading, error }] = useTaskNewCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskNewCommentMutation(baseOptions?: Apollo.MutationHookOptions<GQLTaskNewCommentMutation, GQLTaskNewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTaskNewCommentMutation, GQLTaskNewCommentMutationVariables>(TaskNewCommentDocument, options);
      }
export type TaskNewCommentMutationHookResult = ReturnType<typeof useTaskNewCommentMutation>;
export type TaskNewCommentMutationResult = Apollo.MutationResult<GQLTaskNewCommentMutation>;
export type TaskNewCommentMutationOptions = Apollo.BaseMutationOptions<GQLTaskNewCommentMutation, GQLTaskNewCommentMutationVariables>;
export const TenantNewBranchDocument = gql`
    mutation TenantNewBranch($branchInput: NewBranchParams!) {
  TenantNewBranch(branchInput: $branchInput) {
    success
  }
}
    `;
export type GQLTenantNewBranchMutationFn = Apollo.MutationFunction<GQLTenantNewBranchMutation, GQLTenantNewBranchMutationVariables>;

/**
 * __useTenantNewBranchMutation__
 *
 * To run a mutation, you first call `useTenantNewBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantNewBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantNewBranchMutation, { data, loading, error }] = useTenantNewBranchMutation({
 *   variables: {
 *      branchInput: // value for 'branchInput'
 *   },
 * });
 */
export function useTenantNewBranchMutation(baseOptions?: Apollo.MutationHookOptions<GQLTenantNewBranchMutation, GQLTenantNewBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTenantNewBranchMutation, GQLTenantNewBranchMutationVariables>(TenantNewBranchDocument, options);
      }
export type TenantNewBranchMutationHookResult = ReturnType<typeof useTenantNewBranchMutation>;
export type TenantNewBranchMutationResult = Apollo.MutationResult<GQLTenantNewBranchMutation>;
export type TenantNewBranchMutationOptions = Apollo.BaseMutationOptions<GQLTenantNewBranchMutation, GQLTenantNewBranchMutationVariables>;
export const TenantRegistrationCreateAdminDocument = gql`
    mutation TenantRegistrationCreateAdmin($id: ID!) {
  TenantRegistrationCreateAdmin(registrationID: $id) {
    success
  }
}
    `;
export type GQLTenantRegistrationCreateAdminMutationFn = Apollo.MutationFunction<GQLTenantRegistrationCreateAdminMutation, GQLTenantRegistrationCreateAdminMutationVariables>;

/**
 * __useTenantRegistrationCreateAdminMutation__
 *
 * To run a mutation, you first call `useTenantRegistrationCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantRegistrationCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantRegistrationCreateAdminMutation, { data, loading, error }] = useTenantRegistrationCreateAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTenantRegistrationCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<GQLTenantRegistrationCreateAdminMutation, GQLTenantRegistrationCreateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTenantRegistrationCreateAdminMutation, GQLTenantRegistrationCreateAdminMutationVariables>(TenantRegistrationCreateAdminDocument, options);
      }
export type TenantRegistrationCreateAdminMutationHookResult = ReturnType<typeof useTenantRegistrationCreateAdminMutation>;
export type TenantRegistrationCreateAdminMutationResult = Apollo.MutationResult<GQLTenantRegistrationCreateAdminMutation>;
export type TenantRegistrationCreateAdminMutationOptions = Apollo.BaseMutationOptions<GQLTenantRegistrationCreateAdminMutation, GQLTenantRegistrationCreateAdminMutationVariables>;
export const TenantRegistrationSetStatusDocument = gql`
    mutation TenantRegistrationSetStatus($registrationID: ID!, $status: RegistrationStatus!) {
  TenantRegistrationSetStatus(registrationID: $registrationID, status: $status) {
    success
  }
}
    `;
export type GQLTenantRegistrationSetStatusMutationFn = Apollo.MutationFunction<GQLTenantRegistrationSetStatusMutation, GQLTenantRegistrationSetStatusMutationVariables>;

/**
 * __useTenantRegistrationSetStatusMutation__
 *
 * To run a mutation, you first call `useTenantRegistrationSetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantRegistrationSetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantRegistrationSetStatusMutation, { data, loading, error }] = useTenantRegistrationSetStatusMutation({
 *   variables: {
 *      registrationID: // value for 'registrationID'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useTenantRegistrationSetStatusMutation(baseOptions?: Apollo.MutationHookOptions<GQLTenantRegistrationSetStatusMutation, GQLTenantRegistrationSetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTenantRegistrationSetStatusMutation, GQLTenantRegistrationSetStatusMutationVariables>(TenantRegistrationSetStatusDocument, options);
      }
export type TenantRegistrationSetStatusMutationHookResult = ReturnType<typeof useTenantRegistrationSetStatusMutation>;
export type TenantRegistrationSetStatusMutationResult = Apollo.MutationResult<GQLTenantRegistrationSetStatusMutation>;
export type TenantRegistrationSetStatusMutationOptions = Apollo.BaseMutationOptions<GQLTenantRegistrationSetStatusMutation, GQLTenantRegistrationSetStatusMutationVariables>;
export const TenantSetStatusDocument = gql`
    mutation TenantSetStatus($input: TenantSetStatusParams!) {
  TenantSetStatus(input: $input) {
    success
  }
}
    `;
export type GQLTenantSetStatusMutationFn = Apollo.MutationFunction<GQLTenantSetStatusMutation, GQLTenantSetStatusMutationVariables>;

/**
 * __useTenantSetStatusMutation__
 *
 * To run a mutation, you first call `useTenantSetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantSetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantSetStatusMutation, { data, loading, error }] = useTenantSetStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTenantSetStatusMutation(baseOptions?: Apollo.MutationHookOptions<GQLTenantSetStatusMutation, GQLTenantSetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTenantSetStatusMutation, GQLTenantSetStatusMutationVariables>(TenantSetStatusDocument, options);
      }
export type TenantSetStatusMutationHookResult = ReturnType<typeof useTenantSetStatusMutation>;
export type TenantSetStatusMutationResult = Apollo.MutationResult<GQLTenantSetStatusMutation>;
export type TenantSetStatusMutationOptions = Apollo.BaseMutationOptions<GQLTenantSetStatusMutation, GQLTenantSetStatusMutationVariables>;
export const TenantUpdateBranchDocument = gql`
    mutation TenantUpdateBranch($branchInput: UpdateBranchParams!) {
  TenantUpdateBranch(branchInput: $branchInput) {
    success
  }
}
    `;
export type GQLTenantUpdateBranchMutationFn = Apollo.MutationFunction<GQLTenantUpdateBranchMutation, GQLTenantUpdateBranchMutationVariables>;

/**
 * __useTenantUpdateBranchMutation__
 *
 * To run a mutation, you first call `useTenantUpdateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantUpdateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantUpdateBranchMutation, { data, loading, error }] = useTenantUpdateBranchMutation({
 *   variables: {
 *      branchInput: // value for 'branchInput'
 *   },
 * });
 */
export function useTenantUpdateBranchMutation(baseOptions?: Apollo.MutationHookOptions<GQLTenantUpdateBranchMutation, GQLTenantUpdateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLTenantUpdateBranchMutation, GQLTenantUpdateBranchMutationVariables>(TenantUpdateBranchDocument, options);
      }
export type TenantUpdateBranchMutationHookResult = ReturnType<typeof useTenantUpdateBranchMutation>;
export type TenantUpdateBranchMutationResult = Apollo.MutationResult<GQLTenantUpdateBranchMutation>;
export type TenantUpdateBranchMutationOptions = Apollo.BaseMutationOptions<GQLTenantUpdateBranchMutation, GQLTenantUpdateBranchMutationVariables>;
export const UpdateCategoryNameDocument = gql`
    mutation UpdateCategoryName($input: UpdateCategoryNameParams!) {
  UpdateCategoryName(input: $input) {
    success
  }
}
    `;
export type GQLUpdateCategoryNameMutationFn = Apollo.MutationFunction<GQLUpdateCategoryNameMutation, GQLUpdateCategoryNameMutationVariables>;

/**
 * __useUpdateCategoryNameMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryNameMutation, { data, loading, error }] = useUpdateCategoryNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryNameMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateCategoryNameMutation, GQLUpdateCategoryNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateCategoryNameMutation, GQLUpdateCategoryNameMutationVariables>(UpdateCategoryNameDocument, options);
      }
export type UpdateCategoryNameMutationHookResult = ReturnType<typeof useUpdateCategoryNameMutation>;
export type UpdateCategoryNameMutationResult = Apollo.MutationResult<GQLUpdateCategoryNameMutation>;
export type UpdateCategoryNameMutationOptions = Apollo.BaseMutationOptions<GQLUpdateCategoryNameMutation, GQLUpdateCategoryNameMutationVariables>;
export const UpdateContentItemRolesDocument = gql`
    mutation UpdateContentItemRoles($input: UpdateContentItemRoleParams) {
  UpdateContentItemRoles(input: $input) {
    success
  }
}
    `;
export type GQLUpdateContentItemRolesMutationFn = Apollo.MutationFunction<GQLUpdateContentItemRolesMutation, GQLUpdateContentItemRolesMutationVariables>;

/**
 * __useUpdateContentItemRolesMutation__
 *
 * To run a mutation, you first call `useUpdateContentItemRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentItemRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentItemRolesMutation, { data, loading, error }] = useUpdateContentItemRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentItemRolesMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateContentItemRolesMutation, GQLUpdateContentItemRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateContentItemRolesMutation, GQLUpdateContentItemRolesMutationVariables>(UpdateContentItemRolesDocument, options);
      }
export type UpdateContentItemRolesMutationHookResult = ReturnType<typeof useUpdateContentItemRolesMutation>;
export type UpdateContentItemRolesMutationResult = Apollo.MutationResult<GQLUpdateContentItemRolesMutation>;
export type UpdateContentItemRolesMutationOptions = Apollo.BaseMutationOptions<GQLUpdateContentItemRolesMutation, GQLUpdateContentItemRolesMutationVariables>;
export const UpdateCustomFormDocument = gql`
    mutation UpdateCustomForm($formID: Int!, $enabled: Boolean!) {
  UpdateCustomForm(formID: $formID, enabled: $enabled) {
    success
  }
}
    `;
export type GQLUpdateCustomFormMutationFn = Apollo.MutationFunction<GQLUpdateCustomFormMutation, GQLUpdateCustomFormMutationVariables>;

/**
 * __useUpdateCustomFormMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFormMutation, { data, loading, error }] = useUpdateCustomFormMutation({
 *   variables: {
 *      formID: // value for 'formID'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateCustomFormMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateCustomFormMutation, GQLUpdateCustomFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateCustomFormMutation, GQLUpdateCustomFormMutationVariables>(UpdateCustomFormDocument, options);
      }
export type UpdateCustomFormMutationHookResult = ReturnType<typeof useUpdateCustomFormMutation>;
export type UpdateCustomFormMutationResult = Apollo.MutationResult<GQLUpdateCustomFormMutation>;
export type UpdateCustomFormMutationOptions = Apollo.BaseMutationOptions<GQLUpdateCustomFormMutation, GQLUpdateCustomFormMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskParams!) {
  UpdateTask(input: $input) {
    success
  }
}
    `;
export type GQLUpdateTaskMutationFn = Apollo.MutationFunction<GQLUpdateTaskMutation, GQLUpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTaskMutation, GQLUpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTaskMutation, GQLUpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<GQLUpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTaskMutation, GQLUpdateTaskMutationVariables>;
export const UpdateTaskStatusDocument = gql`
    mutation UpdateTaskStatus($input: UpdateTaskStatusParams!) {
  UpdateTaskStatus(input: $input) {
    success
  }
}
    `;
export type GQLUpdateTaskStatusMutationFn = Apollo.MutationFunction<GQLUpdateTaskStatusMutation, GQLUpdateTaskStatusMutationVariables>;

/**
 * __useUpdateTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskStatusMutation, { data, loading, error }] = useUpdateTaskStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTaskStatusMutation, GQLUpdateTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTaskStatusMutation, GQLUpdateTaskStatusMutationVariables>(UpdateTaskStatusDocument, options);
      }
export type UpdateTaskStatusMutationHookResult = ReturnType<typeof useUpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationResult = Apollo.MutationResult<GQLUpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTaskStatusMutation, GQLUpdateTaskStatusMutationVariables>;
export const UpdateTenantFormDocument = gql`
    mutation UpdateTenantForm($formID: Int!, $enabled: Boolean!) {
  UpdateTenantForm(formID: $formID, enabled: $enabled) {
    success
  }
}
    `;
export type GQLUpdateTenantFormMutationFn = Apollo.MutationFunction<GQLUpdateTenantFormMutation, GQLUpdateTenantFormMutationVariables>;

/**
 * __useUpdateTenantFormMutation__
 *
 * To run a mutation, you first call `useUpdateTenantFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantFormMutation, { data, loading, error }] = useUpdateTenantFormMutation({
 *   variables: {
 *      formID: // value for 'formID'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateTenantFormMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTenantFormMutation, GQLUpdateTenantFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTenantFormMutation, GQLUpdateTenantFormMutationVariables>(UpdateTenantFormDocument, options);
      }
export type UpdateTenantFormMutationHookResult = ReturnType<typeof useUpdateTenantFormMutation>;
export type UpdateTenantFormMutationResult = Apollo.MutationResult<GQLUpdateTenantFormMutation>;
export type UpdateTenantFormMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTenantFormMutation, GQLUpdateTenantFormMutationVariables>;
export const UpdateTenantFormPartsByFormIdDocument = gql`
    mutation UpdateTenantFormPartsByFormID($formID: ID!, $formParts: [String!]!) {
  UpdateTenantFormPartsByFormID(formID: $formID, formParts: $formParts) {
    success
  }
}
    `;
export type GQLUpdateTenantFormPartsByFormIdMutationFn = Apollo.MutationFunction<GQLUpdateTenantFormPartsByFormIdMutation, GQLUpdateTenantFormPartsByFormIdMutationVariables>;

/**
 * __useUpdateTenantFormPartsByFormIdMutation__
 *
 * To run a mutation, you first call `useUpdateTenantFormPartsByFormIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantFormPartsByFormIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantFormPartsByFormIdMutation, { data, loading, error }] = useUpdateTenantFormPartsByFormIdMutation({
 *   variables: {
 *      formID: // value for 'formID'
 *      formParts: // value for 'formParts'
 *   },
 * });
 */
export function useUpdateTenantFormPartsByFormIdMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTenantFormPartsByFormIdMutation, GQLUpdateTenantFormPartsByFormIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTenantFormPartsByFormIdMutation, GQLUpdateTenantFormPartsByFormIdMutationVariables>(UpdateTenantFormPartsByFormIdDocument, options);
      }
export type UpdateTenantFormPartsByFormIdMutationHookResult = ReturnType<typeof useUpdateTenantFormPartsByFormIdMutation>;
export type UpdateTenantFormPartsByFormIdMutationResult = Apollo.MutationResult<GQLUpdateTenantFormPartsByFormIdMutation>;
export type UpdateTenantFormPartsByFormIdMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTenantFormPartsByFormIdMutation, GQLUpdateTenantFormPartsByFormIdMutationVariables>;
export const UpdateTenantOrganizationDocument = gql`
    mutation UpdateTenantOrganization($tenantInput: UpdateTenantParams!, $organizationInput: UpdateOrganizationParams!, $enabledFeatures: [ID!]) {
  UpdateTenantOrganization(
    tenantInput: $tenantInput
    organiztionInput: $organizationInput
    enabledFeatures: $enabledFeatures
  ) {
    success
  }
}
    `;
export type GQLUpdateTenantOrganizationMutationFn = Apollo.MutationFunction<GQLUpdateTenantOrganizationMutation, GQLUpdateTenantOrganizationMutationVariables>;

/**
 * __useUpdateTenantOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateTenantOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantOrganizationMutation, { data, loading, error }] = useUpdateTenantOrganizationMutation({
 *   variables: {
 *      tenantInput: // value for 'tenantInput'
 *      organizationInput: // value for 'organizationInput'
 *      enabledFeatures: // value for 'enabledFeatures'
 *   },
 * });
 */
export function useUpdateTenantOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTenantOrganizationMutation, GQLUpdateTenantOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTenantOrganizationMutation, GQLUpdateTenantOrganizationMutationVariables>(UpdateTenantOrganizationDocument, options);
      }
export type UpdateTenantOrganizationMutationHookResult = ReturnType<typeof useUpdateTenantOrganizationMutation>;
export type UpdateTenantOrganizationMutationResult = Apollo.MutationResult<GQLUpdateTenantOrganizationMutation>;
export type UpdateTenantOrganizationMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTenantOrganizationMutation, GQLUpdateTenantOrganizationMutationVariables>;
export const UpdateTenantRegistrationDocument = gql`
    mutation UpdateTenantRegistration($input: UpdateRegistrationParams!) {
  UpdateTenantRegistration(input: $input) {
    success
  }
}
    `;
export type GQLUpdateTenantRegistrationMutationFn = Apollo.MutationFunction<GQLUpdateTenantRegistrationMutation, GQLUpdateTenantRegistrationMutationVariables>;

/**
 * __useUpdateTenantRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateTenantRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantRegistrationMutation, { data, loading, error }] = useUpdateTenantRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTenantRegistrationMutation, GQLUpdateTenantRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTenantRegistrationMutation, GQLUpdateTenantRegistrationMutationVariables>(UpdateTenantRegistrationDocument, options);
      }
export type UpdateTenantRegistrationMutationHookResult = ReturnType<typeof useUpdateTenantRegistrationMutation>;
export type UpdateTenantRegistrationMutationResult = Apollo.MutationResult<GQLUpdateTenantRegistrationMutation>;
export type UpdateTenantRegistrationMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTenantRegistrationMutation, GQLUpdateTenantRegistrationMutationVariables>;
export const UpdateTranslationDocument = gql`
    mutation updateTranslation($input: UpdateTranslationParams!) {
  UpdateTranslation(input: $input) {
    success
  }
}
    `;
export type GQLUpdateTranslationMutationFn = Apollo.MutationFunction<GQLUpdateTranslationMutation, GQLUpdateTranslationMutationVariables>;

/**
 * __useUpdateTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutation, { data, loading, error }] = useUpdateTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranslationMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTranslationMutation, GQLUpdateTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTranslationMutation, GQLUpdateTranslationMutationVariables>(UpdateTranslationDocument, options);
      }
export type UpdateTranslationMutationHookResult = ReturnType<typeof useUpdateTranslationMutation>;
export type UpdateTranslationMutationResult = Apollo.MutationResult<GQLUpdateTranslationMutation>;
export type UpdateTranslationMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTranslationMutation, GQLUpdateTranslationMutationVariables>;
export const UpdateUserByIdDocument = gql`
    mutation UpdateUserByID($input: UpdateUserByIDParams!) {
  UpdateUserByID(input: $input) {
    success
  }
}
    `;
export type GQLUpdateUserByIdMutationFn = Apollo.MutationFunction<GQLUpdateUserByIdMutation, GQLUpdateUserByIdMutationVariables>;

/**
 * __useUpdateUserByIdMutation__
 *
 * To run a mutation, you first call `useUpdateUserByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserByIdMutation, { data, loading, error }] = useUpdateUserByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserByIdMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateUserByIdMutation, GQLUpdateUserByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateUserByIdMutation, GQLUpdateUserByIdMutationVariables>(UpdateUserByIdDocument, options);
      }
export type UpdateUserByIdMutationHookResult = ReturnType<typeof useUpdateUserByIdMutation>;
export type UpdateUserByIdMutationResult = Apollo.MutationResult<GQLUpdateUserByIdMutation>;
export type UpdateUserByIdMutationOptions = Apollo.BaseMutationOptions<GQLUpdateUserByIdMutation, GQLUpdateUserByIdMutationVariables>;
export const AllTenantFeaturesDocument = gql`
    query AllTenantFeatures {
  AllTenantFeatures {
    featureID
    name
    enabled
    featureDescriptionLabel
  }
}
    `;

/**
 * __useAllTenantFeaturesQuery__
 *
 * To run a query within a React component, call `useAllTenantFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTenantFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTenantFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTenantFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GQLAllTenantFeaturesQuery, GQLAllTenantFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLAllTenantFeaturesQuery, GQLAllTenantFeaturesQueryVariables>(AllTenantFeaturesDocument, options);
      }
export function useAllTenantFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLAllTenantFeaturesQuery, GQLAllTenantFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLAllTenantFeaturesQuery, GQLAllTenantFeaturesQueryVariables>(AllTenantFeaturesDocument, options);
        }
export type AllTenantFeaturesQueryHookResult = ReturnType<typeof useAllTenantFeaturesQuery>;
export type AllTenantFeaturesLazyQueryHookResult = ReturnType<typeof useAllTenantFeaturesLazyQuery>;
export type AllTenantFeaturesQueryResult = Apollo.QueryResult<GQLAllTenantFeaturesQuery, GQLAllTenantFeaturesQueryVariables>;
export const AllTenantFormsDocument = gql`
    query AllTenantForms {
  AllTenantForms {
    name
    formID
    customForm
    enabled
    isConfigurable
  }
}
    `;

/**
 * __useAllTenantFormsQuery__
 *
 * To run a query within a React component, call `useAllTenantFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTenantFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTenantFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTenantFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLAllTenantFormsQuery, GQLAllTenantFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLAllTenantFormsQuery, GQLAllTenantFormsQueryVariables>(AllTenantFormsDocument, options);
      }
export function useAllTenantFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLAllTenantFormsQuery, GQLAllTenantFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLAllTenantFormsQuery, GQLAllTenantFormsQueryVariables>(AllTenantFormsDocument, options);
        }
export type AllTenantFormsQueryHookResult = ReturnType<typeof useAllTenantFormsQuery>;
export type AllTenantFormsLazyQueryHookResult = ReturnType<typeof useAllTenantFormsLazyQuery>;
export type AllTenantFormsQueryResult = Apollo.QueryResult<GQLAllTenantFormsQuery, GQLAllTenantFormsQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    emailAddress
    userID
    roles {
      roleID
      roleName
      description
    }
    active
    preferences
    avatar
    permissions
    firstName
    infix
    lastName
    tenantID
    branchID
    branchName
    tenantDetails {
      name
      logo
      config
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<GQLCurrentUserQuery, GQLCurrentUserQueryVariables>;
export const EnabledFeaturesDocument = gql`
    query EnabledFeatures {
  EnabledFeatures
}
    `;

/**
 * __useEnabledFeaturesQuery__
 *
 * To run a query within a React component, call `useEnabledFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GQLEnabledFeaturesQuery, GQLEnabledFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLEnabledFeaturesQuery, GQLEnabledFeaturesQueryVariables>(EnabledFeaturesDocument, options);
      }
export function useEnabledFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLEnabledFeaturesQuery, GQLEnabledFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLEnabledFeaturesQuery, GQLEnabledFeaturesQueryVariables>(EnabledFeaturesDocument, options);
        }
export type EnabledFeaturesQueryHookResult = ReturnType<typeof useEnabledFeaturesQuery>;
export type EnabledFeaturesLazyQueryHookResult = ReturnType<typeof useEnabledFeaturesLazyQuery>;
export type EnabledFeaturesQueryResult = Apollo.QueryResult<GQLEnabledFeaturesQuery, GQLEnabledFeaturesQueryVariables>;
export const GetEnabledFormsDocument = gql`
    query GetEnabledForms {
  EnabledForms {
    formID
    formVersion
    name
    description
    defaultData
  }
}
    `;

/**
 * __useGetEnabledFormsQuery__
 *
 * To run a query within a React component, call `useGetEnabledFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnabledFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>(GetEnabledFormsDocument, options);
      }
export function useGetEnabledFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>(GetEnabledFormsDocument, options);
        }
export type GetEnabledFormsQueryHookResult = ReturnType<typeof useGetEnabledFormsQuery>;
export type GetEnabledFormsLazyQueryHookResult = ReturnType<typeof useGetEnabledFormsLazyQuery>;
export type GetEnabledFormsQueryResult = Apollo.QueryResult<GQLGetEnabledFormsQuery, GQLGetEnabledFormsQueryVariables>;
export const FlatMenusDocument = gql`
    query FlatMenus {
  FlatMenus {
    menuID
    menuOrder
    name
    icon
    route
    parentID
    featureDescriptionLabel
    featureID
    featureName
    permission
  }
}
    `;

/**
 * __useFlatMenusQuery__
 *
 * To run a query within a React component, call `useFlatMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatMenusQuery({
 *   variables: {
 *   },
 * });
 */
export function useFlatMenusQuery(baseOptions?: Apollo.QueryHookOptions<GQLFlatMenusQuery, GQLFlatMenusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLFlatMenusQuery, GQLFlatMenusQueryVariables>(FlatMenusDocument, options);
      }
export function useFlatMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLFlatMenusQuery, GQLFlatMenusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLFlatMenusQuery, GQLFlatMenusQueryVariables>(FlatMenusDocument, options);
        }
export type FlatMenusQueryHookResult = ReturnType<typeof useFlatMenusQuery>;
export type FlatMenusLazyQueryHookResult = ReturnType<typeof useFlatMenusLazyQuery>;
export type FlatMenusQueryResult = Apollo.QueryResult<GQLFlatMenusQuery, GQLFlatMenusQueryVariables>;
export const FormByIdDocument = gql`
    query FormByID($formID: ID!) {
  FormByID(formID: $formID) {
    formID
    formVersion
    name
    description
    formSchema
    uiSchema
    defaultData
  }
}
    `;

/**
 * __useFormByIdQuery__
 *
 * To run a query within a React component, call `useFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormByIdQuery({
 *   variables: {
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useFormByIdQuery(baseOptions: Apollo.QueryHookOptions<GQLFormByIdQuery, GQLFormByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLFormByIdQuery, GQLFormByIdQueryVariables>(FormByIdDocument, options);
      }
export function useFormByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLFormByIdQuery, GQLFormByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLFormByIdQuery, GQLFormByIdQueryVariables>(FormByIdDocument, options);
        }
export type FormByIdQueryHookResult = ReturnType<typeof useFormByIdQuery>;
export type FormByIdLazyQueryHookResult = ReturnType<typeof useFormByIdLazyQuery>;
export type FormByIdQueryResult = Apollo.QueryResult<GQLFormByIdQuery, GQLFormByIdQueryVariables>;
export const FormDesignerByIdDocument = gql`
    query FormDesignerByID($formID: ID!) {
  FormDesignerByID(formID: $formID) {
    formID
    formVersion
    name
    description
    formSchema
    uiSchema
    defaultData
  }
}
    `;

/**
 * __useFormDesignerByIdQuery__
 *
 * To run a query within a React component, call `useFormDesignerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormDesignerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormDesignerByIdQuery({
 *   variables: {
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useFormDesignerByIdQuery(baseOptions: Apollo.QueryHookOptions<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>(FormDesignerByIdDocument, options);
      }
export function useFormDesignerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>(FormDesignerByIdDocument, options);
        }
export type FormDesignerByIdQueryHookResult = ReturnType<typeof useFormDesignerByIdQuery>;
export type FormDesignerByIdLazyQueryHookResult = ReturnType<typeof useFormDesignerByIdLazyQuery>;
export type FormDesignerByIdQueryResult = Apollo.QueryResult<GQLFormDesignerByIdQuery, GQLFormDesignerByIdQueryVariables>;
export const GetAllUserTenantsDocument = gql`
    query GetAllUserTenants {
  AllUserTenants {
    name
    TenantID
  }
}
    `;

/**
 * __useGetAllUserTenantsQuery__
 *
 * To run a query within a React component, call `useGetAllUserTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUserTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>(GetAllUserTenantsDocument, options);
      }
export function useGetAllUserTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>(GetAllUserTenantsDocument, options);
        }
export type GetAllUserTenantsQueryHookResult = ReturnType<typeof useGetAllUserTenantsQuery>;
export type GetAllUserTenantsLazyQueryHookResult = ReturnType<typeof useGetAllUserTenantsLazyQuery>;
export type GetAllUserTenantsQueryResult = Apollo.QueryResult<GQLGetAllUserTenantsQuery, GQLGetAllUserTenantsQueryVariables>;
export const GetAvailableFormsDocument = gql`
    query GetAvailableForms {
  AvailableForms {
    name
    formID
    description
    enabled
    customForm
  }
}
    `;

/**
 * __useGetAvailableFormsQuery__
 *
 * To run a query within a React component, call `useGetAvailableFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>(GetAvailableFormsDocument, options);
      }
export function useGetAvailableFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>(GetAvailableFormsDocument, options);
        }
export type GetAvailableFormsQueryHookResult = ReturnType<typeof useGetAvailableFormsQuery>;
export type GetAvailableFormsLazyQueryHookResult = ReturnType<typeof useGetAvailableFormsLazyQuery>;
export type GetAvailableFormsQueryResult = Apollo.QueryResult<GQLGetAvailableFormsQuery, GQLGetAvailableFormsQueryVariables>;
export const GetCategoryStructureDocument = gql`
    query GetCategoryStructure {
  CategoryStructure {
    categoryID
    name
    children {
      categoryID
      name
    }
    items {
      itemID
      name
      description
      createdAt
      createdBy
      sensitivityLevel
      deleted
      mimetype
      downloadUrl
      roles
    }
  }
}
    `;

/**
 * __useGetCategoryStructureQuery__
 *
 * To run a query within a React component, call `useGetCategoryStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryStructureQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoryStructureQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>(GetCategoryStructureDocument, options);
      }
export function useGetCategoryStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>(GetCategoryStructureDocument, options);
        }
export type GetCategoryStructureQueryHookResult = ReturnType<typeof useGetCategoryStructureQuery>;
export type GetCategoryStructureLazyQueryHookResult = ReturnType<typeof useGetCategoryStructureLazyQuery>;
export type GetCategoryStructureQueryResult = Apollo.QueryResult<GQLGetCategoryStructureQuery, GQLGetCategoryStructureQueryVariables>;
export const GetContentItemsByCategoryIdDocument = gql`
    query GetContentItemsByCategoryID($id: ID!) {
  ContentItemsByCategoryID(categoryID: $id) {
    itemID
    name
    description
    createdAt
    createdBy
    sensitivityLevel
    deleted
    roles
    mimetype
  }
}
    `;

/**
 * __useGetContentItemsByCategoryIdQuery__
 *
 * To run a query within a React component, call `useGetContentItemsByCategoryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentItemsByCategoryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentItemsByCategoryIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentItemsByCategoryIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>(GetContentItemsByCategoryIdDocument, options);
      }
export function useGetContentItemsByCategoryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>(GetContentItemsByCategoryIdDocument, options);
        }
export type GetContentItemsByCategoryIdQueryHookResult = ReturnType<typeof useGetContentItemsByCategoryIdQuery>;
export type GetContentItemsByCategoryIdLazyQueryHookResult = ReturnType<typeof useGetContentItemsByCategoryIdLazyQuery>;
export type GetContentItemsByCategoryIdQueryResult = Apollo.QueryResult<GQLGetContentItemsByCategoryIdQuery, GQLGetContentItemsByCategoryIdQueryVariables>;
export const GetDisabledTenantFormPartsByFormIdDocument = gql`
    query GetDisabledTenantFormPartsByFormID($formID: ID!) {
  DisabledTenantFormPartsByFormID(formID: $formID) {
    name
    formPartID
    formID
  }
}
    `;

/**
 * __useGetDisabledTenantFormPartsByFormIdQuery__
 *
 * To run a query within a React component, call `useGetDisabledTenantFormPartsByFormIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisabledTenantFormPartsByFormIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisabledTenantFormPartsByFormIdQuery({
 *   variables: {
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useGetDisabledTenantFormPartsByFormIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>(GetDisabledTenantFormPartsByFormIdDocument, options);
      }
export function useGetDisabledTenantFormPartsByFormIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>(GetDisabledTenantFormPartsByFormIdDocument, options);
        }
export type GetDisabledTenantFormPartsByFormIdQueryHookResult = ReturnType<typeof useGetDisabledTenantFormPartsByFormIdQuery>;
export type GetDisabledTenantFormPartsByFormIdLazyQueryHookResult = ReturnType<typeof useGetDisabledTenantFormPartsByFormIdLazyQuery>;
export type GetDisabledTenantFormPartsByFormIdQueryResult = Apollo.QueryResult<GQLGetDisabledTenantFormPartsByFormIdQuery, GQLGetDisabledTenantFormPartsByFormIdQueryVariables>;
export const GetEnabledTenantFormPartsByFormIdDocument = gql`
    query GetEnabledTenantFormPartsByFormID($formID: ID!) {
  EnabledTenantFormPartsByFormID(formID: $formID) {
    name
    formPartID
    formID
  }
}
    `;

/**
 * __useGetEnabledTenantFormPartsByFormIdQuery__
 *
 * To run a query within a React component, call `useGetEnabledTenantFormPartsByFormIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledTenantFormPartsByFormIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledTenantFormPartsByFormIdQuery({
 *   variables: {
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useGetEnabledTenantFormPartsByFormIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>(GetEnabledTenantFormPartsByFormIdDocument, options);
      }
export function useGetEnabledTenantFormPartsByFormIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>(GetEnabledTenantFormPartsByFormIdDocument, options);
        }
export type GetEnabledTenantFormPartsByFormIdQueryHookResult = ReturnType<typeof useGetEnabledTenantFormPartsByFormIdQuery>;
export type GetEnabledTenantFormPartsByFormIdLazyQueryHookResult = ReturnType<typeof useGetEnabledTenantFormPartsByFormIdLazyQuery>;
export type GetEnabledTenantFormPartsByFormIdQueryResult = Apollo.QueryResult<GQLGetEnabledTenantFormPartsByFormIdQuery, GQLGetEnabledTenantFormPartsByFormIdQueryVariables>;
export const GetFormResultByIdDocument = gql`
    query GetFormResultByID($id: ID!) {
  FormResultByID(formResultID: $id) {
    formResultID
    formID
    formVersion
    createdBy {
      firstName
      infix
      lastName
      tenantID
    }
    name
    formSchema
    uiSchema
    formData
    createdAt
    submittedAt
  }
}
    `;

/**
 * __useGetFormResultByIdQuery__
 *
 * To run a query within a React component, call `useGetFormResultByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormResultByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormResultByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormResultByIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>(GetFormResultByIdDocument, options);
      }
export function useGetFormResultByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>(GetFormResultByIdDocument, options);
        }
export type GetFormResultByIdQueryHookResult = ReturnType<typeof useGetFormResultByIdQuery>;
export type GetFormResultByIdLazyQueryHookResult = ReturnType<typeof useGetFormResultByIdLazyQuery>;
export type GetFormResultByIdQueryResult = Apollo.QueryResult<GQLGetFormResultByIdQuery, GQLGetFormResultByIdQueryVariables>;
export const GetKpiDraftFormsDocument = gql`
    query GetKPIDraftForms {
  KPIDraftForms
}
    `;

/**
 * __useGetKpiDraftFormsQuery__
 *
 * To run a query within a React component, call `useGetKpiDraftFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiDraftFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiDraftFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiDraftFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>(GetKpiDraftFormsDocument, options);
      }
export function useGetKpiDraftFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>(GetKpiDraftFormsDocument, options);
        }
export type GetKpiDraftFormsQueryHookResult = ReturnType<typeof useGetKpiDraftFormsQuery>;
export type GetKpiDraftFormsLazyQueryHookResult = ReturnType<typeof useGetKpiDraftFormsLazyQuery>;
export type GetKpiDraftFormsQueryResult = Apollo.QueryResult<GQLGetKpiDraftFormsQuery, GQLGetKpiDraftFormsQueryVariables>;
export const GetKpiIncidentsByCategoryDocument = gql`
    query GetKPIIncidentsByCategory {
  KPIIncidentsByCategory {
    category
    count
  }
}
    `;

/**
 * __useGetKpiIncidentsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetKpiIncidentsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiIncidentsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiIncidentsByCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiIncidentsByCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>(GetKpiIncidentsByCategoryDocument, options);
      }
export function useGetKpiIncidentsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>(GetKpiIncidentsByCategoryDocument, options);
        }
export type GetKpiIncidentsByCategoryQueryHookResult = ReturnType<typeof useGetKpiIncidentsByCategoryQuery>;
export type GetKpiIncidentsByCategoryLazyQueryHookResult = ReturnType<typeof useGetKpiIncidentsByCategoryLazyQuery>;
export type GetKpiIncidentsByCategoryQueryResult = Apollo.QueryResult<GQLGetKpiIncidentsByCategoryQuery, GQLGetKpiIncidentsByCategoryQueryVariables>;
export const GetKpiSubmittedForms12MonthsDocument = gql`
    query GetKPISubmittedForms12Months {
  KPISubmittedForms12Months
}
    `;

/**
 * __useGetKpiSubmittedForms12MonthsQuery__
 *
 * To run a query within a React component, call `useGetKpiSubmittedForms12MonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiSubmittedForms12MonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiSubmittedForms12MonthsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiSubmittedForms12MonthsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>(GetKpiSubmittedForms12MonthsDocument, options);
      }
export function useGetKpiSubmittedForms12MonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>(GetKpiSubmittedForms12MonthsDocument, options);
        }
export type GetKpiSubmittedForms12MonthsQueryHookResult = ReturnType<typeof useGetKpiSubmittedForms12MonthsQuery>;
export type GetKpiSubmittedForms12MonthsLazyQueryHookResult = ReturnType<typeof useGetKpiSubmittedForms12MonthsLazyQuery>;
export type GetKpiSubmittedForms12MonthsQueryResult = Apollo.QueryResult<GQLGetKpiSubmittedForms12MonthsQuery, GQLGetKpiSubmittedForms12MonthsQueryVariables>;
export const GetKpiSubmittedWpi12MonthsDocument = gql`
    query GetKPISubmittedWPI12Months {
  KPISubmittedWPI12Months
}
    `;

/**
 * __useGetKpiSubmittedWpi12MonthsQuery__
 *
 * To run a query within a React component, call `useGetKpiSubmittedWpi12MonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiSubmittedWpi12MonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiSubmittedWpi12MonthsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKpiSubmittedWpi12MonthsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>(GetKpiSubmittedWpi12MonthsDocument, options);
      }
export function useGetKpiSubmittedWpi12MonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>(GetKpiSubmittedWpi12MonthsDocument, options);
        }
export type GetKpiSubmittedWpi12MonthsQueryHookResult = ReturnType<typeof useGetKpiSubmittedWpi12MonthsQuery>;
export type GetKpiSubmittedWpi12MonthsLazyQueryHookResult = ReturnType<typeof useGetKpiSubmittedWpi12MonthsLazyQuery>;
export type GetKpiSubmittedWpi12MonthsQueryResult = Apollo.QueryResult<GQLGetKpiSubmittedWpi12MonthsQuery, GQLGetKpiSubmittedWpi12MonthsQueryVariables>;
export const GetOpenTenantRegistrationsDocument = gql`
    query GetOpenTenantRegistrations {
  OpenTenantRegistrations {
    registrationID
    tenantID
    name
    street
    houseNumber
    postalCode
    city
    emailAddressInvoice
    adminEmailAddress
    adminFirstName
    adminInfix
    adminLastName
    adminPhoneNumber
    purchaseNumber
    status
    isTrial
  }
}
    `;

/**
 * __useGetOpenTenantRegistrationsQuery__
 *
 * To run a query within a React component, call `useGetOpenTenantRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenTenantRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenTenantRegistrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpenTenantRegistrationsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>(GetOpenTenantRegistrationsDocument, options);
      }
export function useGetOpenTenantRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>(GetOpenTenantRegistrationsDocument, options);
        }
export type GetOpenTenantRegistrationsQueryHookResult = ReturnType<typeof useGetOpenTenantRegistrationsQuery>;
export type GetOpenTenantRegistrationsLazyQueryHookResult = ReturnType<typeof useGetOpenTenantRegistrationsLazyQuery>;
export type GetOpenTenantRegistrationsQueryResult = Apollo.QueryResult<GQLGetOpenTenantRegistrationsQuery, GQLGetOpenTenantRegistrationsQueryVariables>;
export const GetSubmittedFormsDocument = gql`
    query GetSubmittedForms($input: SubmittedFormsParams!) {
  SubmittedForms(input: $input) {
    formResultID
    formID
    formVersion
    createdBy {
      firstName
      infix
      lastName
      tenantID
    }
    name
    createdAt
    submittedAt
  }
}
    `;

/**
 * __useGetSubmittedFormsQuery__
 *
 * To run a query within a React component, call `useGetSubmittedFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmittedFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmittedFormsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSubmittedFormsQuery(baseOptions: Apollo.QueryHookOptions<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>(GetSubmittedFormsDocument, options);
      }
export function useGetSubmittedFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>(GetSubmittedFormsDocument, options);
        }
export type GetSubmittedFormsQueryHookResult = ReturnType<typeof useGetSubmittedFormsQuery>;
export type GetSubmittedFormsLazyQueryHookResult = ReturnType<typeof useGetSubmittedFormsLazyQuery>;
export type GetSubmittedFormsQueryResult = Apollo.QueryResult<GQLGetSubmittedFormsQuery, GQLGetSubmittedFormsQueryVariables>;
export const GetTaskByTaskIdDocument = gql`
    query GetTaskByTaskID($id: ID!) {
  TaskByTaskID(taskID: $id) {
    taskID
    summary
    status
    type
    priority
    createdBy
    createdAt
    assignedTo
    assignedToName
    dueDate
    branchID
    url
  }
}
    `;

/**
 * __useGetTaskByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetTaskByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskByTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>(GetTaskByTaskIdDocument, options);
      }
export function useGetTaskByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>(GetTaskByTaskIdDocument, options);
        }
export type GetTaskByTaskIdQueryHookResult = ReturnType<typeof useGetTaskByTaskIdQuery>;
export type GetTaskByTaskIdLazyQueryHookResult = ReturnType<typeof useGetTaskByTaskIdLazyQuery>;
export type GetTaskByTaskIdQueryResult = Apollo.QueryResult<GQLGetTaskByTaskIdQuery, GQLGetTaskByTaskIdQueryVariables>;
export const GetTaskCommentsByTaskIdDocument = gql`
    query GetTaskCommentsByTaskID($id: ID!) {
  TaskCommentsByTaskID(taskID: $id) {
    commentID
    taskID
    description
    createdBy
    createdAt
  }
}
    `;

/**
 * __useGetTaskCommentsByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetTaskCommentsByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCommentsByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCommentsByTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskCommentsByTaskIdQuery(baseOptions: Apollo.QueryHookOptions<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>(GetTaskCommentsByTaskIdDocument, options);
      }
export function useGetTaskCommentsByTaskIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>(GetTaskCommentsByTaskIdDocument, options);
        }
export type GetTaskCommentsByTaskIdQueryHookResult = ReturnType<typeof useGetTaskCommentsByTaskIdQuery>;
export type GetTaskCommentsByTaskIdLazyQueryHookResult = ReturnType<typeof useGetTaskCommentsByTaskIdLazyQuery>;
export type GetTaskCommentsByTaskIdQueryResult = Apollo.QueryResult<GQLGetTaskCommentsByTaskIdQuery, GQLGetTaskCommentsByTaskIdQueryVariables>;
export const GetTaskOverviewDocument = gql`
    query GetTaskOverview($filter: TaskWithfilterOptionsParams!) {
  TaskOverview(filter: $filter) {
    FormResultID
    taskID
    summary
    status
    type
    priority
    createdBy
    createdAt
    assignedTo
    assignedToName
    dueDate
    url
    branchID
    branchName
  }
}
    `;

/**
 * __useGetTaskOverviewQuery__
 *
 * To run a query within a React component, call `useGetTaskOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskOverviewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTaskOverviewQuery(baseOptions: Apollo.QueryHookOptions<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>(GetTaskOverviewDocument, options);
      }
export function useGetTaskOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>(GetTaskOverviewDocument, options);
        }
export type GetTaskOverviewQueryHookResult = ReturnType<typeof useGetTaskOverviewQuery>;
export type GetTaskOverviewLazyQueryHookResult = ReturnType<typeof useGetTaskOverviewLazyQuery>;
export type GetTaskOverviewQueryResult = Apollo.QueryResult<GQLGetTaskOverviewQuery, GQLGetTaskOverviewQueryVariables>;
export const TaskOverviewByFormResultIdDocument = gql`
    query TaskOverviewByFormResultID($formResultID: ID!) {
  TaskOverviewByFormResultID(formResultID: $formResultID) {
    taskID
    summary
    status
    type
    priority
    createdBy
    createdAt
    assignedTo
    assignedToName
    dueDate
    FormResultID
    url
    branchID
    branchName
  }
}
    `;

/**
 * __useTaskOverviewByFormResultIdQuery__
 *
 * To run a query within a React component, call `useTaskOverviewByFormResultIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskOverviewByFormResultIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskOverviewByFormResultIdQuery({
 *   variables: {
 *      formResultID: // value for 'formResultID'
 *   },
 * });
 */
export function useTaskOverviewByFormResultIdQuery(baseOptions: Apollo.QueryHookOptions<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>(TaskOverviewByFormResultIdDocument, options);
      }
export function useTaskOverviewByFormResultIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>(TaskOverviewByFormResultIdDocument, options);
        }
export type TaskOverviewByFormResultIdQueryHookResult = ReturnType<typeof useTaskOverviewByFormResultIdQuery>;
export type TaskOverviewByFormResultIdLazyQueryHookResult = ReturnType<typeof useTaskOverviewByFormResultIdLazyQuery>;
export type TaskOverviewByFormResultIdQueryResult = Apollo.QueryResult<GQLTaskOverviewByFormResultIdQuery, GQLTaskOverviewByFormResultIdQueryVariables>;
export const GetTenantOrganizationDetailsDocument = gql`
    query GetTenantOrganizationDetails {
  TenantOrganizationDetails {
    organizationID
    tenantID
    name
    logo
    street
    houseNumber
    postalCode
    city
    emailAddressInvoice
    purchaseNumber
    enabled
    enabledFeatures {
      featureID
      name
      enabled
      featureDescriptionLabel
    }
    createdAt
    trialStartDate
    status
  }
}
    `;

/**
 * __useGetTenantOrganizationDetailsQuery__
 *
 * To run a query within a React component, call `useGetTenantOrganizationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantOrganizationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantOrganizationDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantOrganizationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>(GetTenantOrganizationDetailsDocument, options);
      }
export function useGetTenantOrganizationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>(GetTenantOrganizationDetailsDocument, options);
        }
export type GetTenantOrganizationDetailsQueryHookResult = ReturnType<typeof useGetTenantOrganizationDetailsQuery>;
export type GetTenantOrganizationDetailsLazyQueryHookResult = ReturnType<typeof useGetTenantOrganizationDetailsLazyQuery>;
export type GetTenantOrganizationDetailsQueryResult = Apollo.QueryResult<GQLGetTenantOrganizationDetailsQuery, GQLGetTenantOrganizationDetailsQueryVariables>;
export const GetTranslationsDocument = gql`
    query GetTranslations {
  Translations {
    id
    namespace
    key
    en
    nl
  }
}
    `;

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>(GetTranslationsDocument, options);
      }
export function useGetTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>(GetTranslationsDocument, options);
        }
export type GetTranslationsQueryHookResult = ReturnType<typeof useGetTranslationsQuery>;
export type GetTranslationsLazyQueryHookResult = ReturnType<typeof useGetTranslationsLazyQuery>;
export type GetTranslationsQueryResult = Apollo.QueryResult<GQLGetTranslationsQuery, GQLGetTranslationsQueryVariables>;
export const GetUserAccountsDocument = gql`
    query GetUserAccounts($active: Boolean) {
  UserAccounts(active: $active) {
    emailAddress
    userID
    roles {
      roleID
      roleName
      description
    }
    active
    preferences
    branchID
    branchName
    permissions
    firstName
    infix
    lastName
    tenantID
    fullName
  }
}
    `;

/**
 * __useGetUserAccountsQuery__
 *
 * To run a query within a React component, call `useGetUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountsQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetUserAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>(GetUserAccountsDocument, options);
      }
export function useGetUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>(GetUserAccountsDocument, options);
        }
export type GetUserAccountsQueryHookResult = ReturnType<typeof useGetUserAccountsQuery>;
export type GetUserAccountsLazyQueryHookResult = ReturnType<typeof useGetUserAccountsLazyQuery>;
export type GetUserAccountsQueryResult = Apollo.QueryResult<GQLGetUserAccountsQuery, GQLGetUserAccountsQueryVariables>;
export const GetUserListDocument = gql`
    query GetUserList($active: Boolean) {
  UserAccounts(active: $active) {
    id: userID
    name: fullName
  }
}
    `;

/**
 * __useGetUserListQuery__
 *
 * To run a query within a React component, call `useGetUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetUserListQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetUserListQuery, GQLGetUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetUserListQuery, GQLGetUserListQueryVariables>(GetUserListDocument, options);
      }
export function useGetUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetUserListQuery, GQLGetUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetUserListQuery, GQLGetUserListQueryVariables>(GetUserListDocument, options);
        }
export type GetUserListQueryHookResult = ReturnType<typeof useGetUserListQuery>;
export type GetUserListLazyQueryHookResult = ReturnType<typeof useGetUserListLazyQuery>;
export type GetUserListQueryResult = Apollo.QueryResult<GQLGetUserListQuery, GQLGetUserListQueryVariables>;
export const IsPermittedDocument = gql`
    query ISPermitted($permission: String!) {
  IsPermitted(permission: $permission)
}
    `;

/**
 * __useIsPermittedQuery__
 *
 * To run a query within a React component, call `useIsPermittedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPermittedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPermittedQuery({
 *   variables: {
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useIsPermittedQuery(baseOptions: Apollo.QueryHookOptions<GQLIsPermittedQuery, GQLIsPermittedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLIsPermittedQuery, GQLIsPermittedQueryVariables>(IsPermittedDocument, options);
      }
export function useIsPermittedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLIsPermittedQuery, GQLIsPermittedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLIsPermittedQuery, GQLIsPermittedQueryVariables>(IsPermittedDocument, options);
        }
export type IsPermittedQueryHookResult = ReturnType<typeof useIsPermittedQuery>;
export type IsPermittedLazyQueryHookResult = ReturnType<typeof useIsPermittedLazyQuery>;
export type IsPermittedQueryResult = Apollo.QueryResult<GQLIsPermittedQuery, GQLIsPermittedQueryVariables>;
export const GetMyDraftFormsDocument = gql`
    query GetMyDraftForms {
  MyDraftForms {
    formResultID
    formID
    formVersion
    name
    description
    formSchema
    uiSchema
    formData
    createdAt
  }
}
    `;

/**
 * __useGetMyDraftFormsQuery__
 *
 * To run a query within a React component, call `useGetMyDraftFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDraftFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDraftFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyDraftFormsQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>(GetMyDraftFormsDocument, options);
      }
export function useGetMyDraftFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>(GetMyDraftFormsDocument, options);
        }
export type GetMyDraftFormsQueryHookResult = ReturnType<typeof useGetMyDraftFormsQuery>;
export type GetMyDraftFormsLazyQueryHookResult = ReturnType<typeof useGetMyDraftFormsLazyQuery>;
export type GetMyDraftFormsQueryResult = Apollo.QueryResult<GQLGetMyDraftFormsQuery, GQLGetMyDraftFormsQueryVariables>;
export const MyOpenTasksDocument = gql`
    query MyOpenTasks {
  MyOpenTasks {
    taskID
    FormResultID
    summary
    status
    type
    priority
    createdBy
    createdAt
    assignedTo
    assignedToName
    dueDate
    url
    branchID
    branchName
  }
}
    `;

/**
 * __useMyOpenTasksQuery__
 *
 * To run a query within a React component, call `useMyOpenTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOpenTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOpenTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyOpenTasksQuery(baseOptions?: Apollo.QueryHookOptions<GQLMyOpenTasksQuery, GQLMyOpenTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLMyOpenTasksQuery, GQLMyOpenTasksQueryVariables>(MyOpenTasksDocument, options);
      }
export function useMyOpenTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLMyOpenTasksQuery, GQLMyOpenTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLMyOpenTasksQuery, GQLMyOpenTasksQueryVariables>(MyOpenTasksDocument, options);
        }
export type MyOpenTasksQueryHookResult = ReturnType<typeof useMyOpenTasksQuery>;
export type MyOpenTasksLazyQueryHookResult = ReturnType<typeof useMyOpenTasksLazyQuery>;
export type MyOpenTasksQueryResult = Apollo.QueryResult<GQLMyOpenTasksQuery, GQLMyOpenTasksQueryVariables>;
export const GetUserRolesDocument = gql`
    query GetUserRoles {
  Roles {
    roleID
    roleName
  }
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a React component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>(GetUserRolesDocument, options);
      }
export function useGetUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>(GetUserRolesDocument, options);
        }
export type GetUserRolesQueryHookResult = ReturnType<typeof useGetUserRolesQuery>;
export type GetUserRolesLazyQueryHookResult = ReturnType<typeof useGetUserRolesLazyQuery>;
export type GetUserRolesQueryResult = Apollo.QueryResult<GQLGetUserRolesQuery, GQLGetUserRolesQueryVariables>;
export const TenantBranchByIdDocument = gql`
    query TenantBranchByID($branchID: ID!) {
  TenantBranchByID(branchID: $branchID) {
    branchID
    branchName
    branchType
    tenantID
  }
}
    `;

/**
 * __useTenantBranchByIdQuery__
 *
 * To run a query within a React component, call `useTenantBranchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantBranchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantBranchByIdQuery({
 *   variables: {
 *      branchID: // value for 'branchID'
 *   },
 * });
 */
export function useTenantBranchByIdQuery(baseOptions: Apollo.QueryHookOptions<GQLTenantBranchByIdQuery, GQLTenantBranchByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLTenantBranchByIdQuery, GQLTenantBranchByIdQueryVariables>(TenantBranchByIdDocument, options);
      }
export function useTenantBranchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLTenantBranchByIdQuery, GQLTenantBranchByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLTenantBranchByIdQuery, GQLTenantBranchByIdQueryVariables>(TenantBranchByIdDocument, options);
        }
export type TenantBranchByIdQueryHookResult = ReturnType<typeof useTenantBranchByIdQuery>;
export type TenantBranchByIdLazyQueryHookResult = ReturnType<typeof useTenantBranchByIdLazyQuery>;
export type TenantBranchByIdQueryResult = Apollo.QueryResult<GQLTenantBranchByIdQuery, GQLTenantBranchByIdQueryVariables>;
export const TenantBranchesDocument = gql`
    query TenantBranches {
  TenantBranches {
    branchID
    branchName
    branchType
    tenantID
  }
}
    `;

/**
 * __useTenantBranchesQuery__
 *
 * To run a query within a React component, call `useTenantBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantBranchesQuery(baseOptions?: Apollo.QueryHookOptions<GQLTenantBranchesQuery, GQLTenantBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLTenantBranchesQuery, GQLTenantBranchesQueryVariables>(TenantBranchesDocument, options);
      }
export function useTenantBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLTenantBranchesQuery, GQLTenantBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLTenantBranchesQuery, GQLTenantBranchesQueryVariables>(TenantBranchesDocument, options);
        }
export type TenantBranchesQueryHookResult = ReturnType<typeof useTenantBranchesQuery>;
export type TenantBranchesLazyQueryHookResult = ReturnType<typeof useTenantBranchesLazyQuery>;
export type TenantBranchesQueryResult = Apollo.QueryResult<GQLTenantBranchesQuery, GQLTenantBranchesQueryVariables>;